<template>
  <div>
    <!-- 企业开户/修改 -->
    <a-card style="margin: 20px">
      <template #title>
        <div class="top-title">
          <div class="left">
            <span>账户管理</span>
            <a-icon type="right"/>
            <span>{{ isEditMode ? '修改账户' : '企业开户' }}</span>
          </div>
          <div style="display: flex">
            <div v-if="!isEditMode" class="agreement">
              <div class="item">
                <a-checkbox v-model="Userauthorization">
                  本人已阅读并同意
                  <a-tooltip>
                    <template slot="title"> 点击下载</template>
                    <a-button type="link" size="small" @click="downLoadTemplate('TMPL_CZCB_SRVC')">{{
                        mapMapList('TMPL_CZCB_SRVC').state
                      }}
                    </a-button>
                  </a-tooltip>
                  <a-tooltip>
                    <template slot="title"> 点击下载</template>
                    <a-button type="link" size="small" @click="downLoadTemplate('TMPL_CZCB_PRVC')">{{
                        mapMapList('TMPL_CZCB_PRVC').state
                      }}
                    </a-button>
                  </a-tooltip>
                </a-checkbox>
              </div>
            </div>
            <div class="right">
              <!-- 确认 -->
              <a-button type="primary" @click="confirm"> 确认</a-button>
              <!-- 取消 -->
              <a-button @click="cancelshow = true"> 取消</a-button>
            </div>
          </div>
        </div>
      </template>
      <!-- 企业开户/修改页面 -->
      <div class="Individualaccountopening">
        <!-- 基础信息 -->
        <div class="formbox">
          <div class="toptitle">基础信息*</div>
          <a-form-model ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
            <!-- 渠道编号（开户时显示） -->
            <a-form-model-item v-if="!isEditMode" ref="channelNo" class="channelNo" label="渠道归属" prop="channelNo">
              <a-select v-model.trim="form.channelNo" @change="channel_nochange" placeholder="请选择核心企业"
                        style="width: 200px">
                <a-select-option v-for="item in companylist" :key="item.value" :value="item.value">
                  {{ item.label }}
                </a-select-option>
              </a-select>
            </a-form-model-item>

            <!-- 客户名称 -->
            <a-form-model-item ref="accountName" label="客户" prop="accountName">
              <CustChooseDialog custtypecd="2" :department-id="form.departmentId" v-model="form.accountName"
                                :custnum="form.custnum" @chooseDone="onCustChosen" :disabled="isEditMode">
              </CustChooseDialog>
            </a-form-model-item>

            <!-- 应用编号 -->
            <a-form-model-item class="appNo" ref="appNo" prop="appNo" style="display: none">
              <template #label>
                <span>应用编号</span>
              </template>
              <a-input :disabled="true" v-model.trim="form.appNo" placeholder="请输入应用编号"></a-input>
            </a-form-model-item>

            <!-- 证件类型 -->
            <a-form-model-item label="证件类型" class="idType" ref="idType" prop="idType"  >
              <a-radio-group v-model="form.idType">
                <a-radio value="C">营业执照</a-radio>
                <a-radio value="E">个体工商户</a-radio>
              </a-radio-group>
            </a-form-model-item>

            <!-- 证件号码 -->
            <a-form-model-item label="营业执照/统一社会信用代码" class="idNo" ref="idNo" prop="idNo" :wrapperCol="{ span: 16 }">
              <div style="display: flex; align-items: center; gap: 8px;">
                <a-input v-model.trim="form.idNo" @change="id_nochange" placeholder="请输入18位营业执照编号" :disabled="isEditMode" style="flex: 1;"></a-input>
                <a-button type="primary" @click="queryBeneficiary" :loading="beneficiaryLoading">查询受益人</a-button>
              </div>
            </a-form-model-item>

            <!-- 证件生效日期 -->
            <a-form-model-item label="营业执照发放日" class="idStartDate" ref="idStartDate" prop="idStartDate">
              <a-date-picker style="width: 200px" valueFormat="YYYY-MM-DD" v-model.trim="form.idStartDate"/>
            </a-form-model-item>

            <!-- 证件失效日期 -->
            <a-form-model-item label="营业执照到期日" class="idEndDate" ref="idEndDate" prop="idEndDate">
              <a-date-picker style="width: 200px" ref="datePicker" valueFormat="YYYY-MM-DD"
                             v-model.trim="form.idEndDate">
              </a-date-picker>
              <a-checkbox v-model="checkBoxValue" style="margin-left: 50px" @change="
                $event.target.checked
                  ? (form.idEndDate = '9999-12-31')
                  : (form.idEndDate = '')
                ">
                长期
              </a-checkbox>
            </a-form-model-item>

            <!-- 签发机关名称 -->
            <a-form-model-item label="营业执照签发机关" class="signName" ref="signName" prop="signName" style="display: none">
              <a-input v-model.trim="form.signName" placeholder="请输入签发机关名称"></a-input>
            </a-form-model-item>

            <!-- 省/直辖市/自治区 -->
            <a-form-model-item prop="distcd" label="居住地省市">
              <el-cascader v-model="form.distcd" :options="citylist" placeholder="请选择所属地区" :props="{ emitPath: false }"
                           style="width: 200px"/>
            </a-form-model-item>

            <!-- 证件地址 -->
            <a-form-model-item label="经营地址" class="idAddress" ref="idAddress" prop="idAddress">
              <a-input v-model.trim="form.idAddress" placeholder="请输入经营地址"></a-input>
            </a-form-model-item>

            <!-- 企业银行卡号 -->
            <a-form-model-item label="企业银行账号" class="primaryAccount" ref="primaryAccount" prop="primaryAccount">
              <a-input :type="'number'" v-model.trim="form.primaryAccount" placeholder="请输入企业银行卡号" :disabled="isEditMode"></a-input>
            </a-form-model-item>

            <!-- 开户行名称 -->
            <a-form-model-item class="bankNo" ref="bankNo" label="开户银行/网点" prop="bankNo">
              <bank-search :bankNo.sync="form.bankNo" :bankName.sync="form.bankName" :disabled="isEditMode"></bank-search>
            </a-form-model-item>

            <!-- 经营范围 -->
            <a-form-model-item label="经营范围" class="zsopscope" ref="zsopscope" prop="zsopscope">
              <a-input v-model.trim="form.zsopscope" placeholder="请输入经营范围"></a-input>
            </a-form-model-item>

            <!-- 行业类别 -->
            <a-form-model-item label="行业类别" class="industry" ref="industry" prop="industry">
              <el-cascader v-model="form.industry" :options="industrylist" placeholder="请选择行业类别" :show-all-levels="false"
                           :props="{ emitPath: false }" style="width: 200px"/>
            </a-form-model-item>

            <!-- 法定代表人 -->
            <div class="legalrepresentative">法定代表人</div>

            <!-- 姓名 -->
            <a-form-model-item label="姓名" class="companyIdName" ref="companyIdName" prop="companyIdName">
              <CustChooseDialog custtypecd="1" :department-id="form.departmentId" @chooseDone="onLrChosen"
                                v-model="form.companyIdName" :disabled="isEditMode">
              </CustChooseDialog>
              <div style="color: red; margin-left: 0">
                *请先在个人客户管理中维护
              </div>
            </a-form-model-item>

            <!-- 证件类型 -->
            <a-form-model-item v-show="false" label="证件类型" class="companyIdType" ref="companyIdType" prop="companyIdType">
              身份证
            </a-form-model-item>

            <!-- 证件号码 -->
            <a-form-model-item label="身份证号" class="companyIdNo" ref="companyIdNo" prop="companyIdNo">
              <a-input v-model.trim="form.companyIdNo" placeholder="请输入证件号码" :disabled="isEditMode"></a-input>
            </a-form-model-item>

            <!-- 证件失效日期 -->
            <a-form-model-item label="身份证到期日" class="companyOpto" ref="companyOpto" prop="companyOpto">
              <a-date-picker style="width: 200px" ref="companyOpto" valueFormat="YYYY-MM-DD"
                             v-model.trim="form.companyOpto">
              </a-date-picker>
              <a-checkbox v-model="id_checked" style="margin-left: 50px" @change="
                $event.target.checked
                  ? (form.companyOpto = '9999-12-31')
                  : (form.companyOpto = '')
                ">
                长期
              </a-checkbox>
            </a-form-model-item>

            <!-- 影像信息 -->
            <div class="legalrepresentative">影像信息</div>
            <a-form-model-item class="pricebox" ref="pricebox" prop="pricebox">
              <template #label>
                <span class="custom-label">
                  <span style="color: #ff0000">*</span> 影像信息</span>
              </template>
              <div class="row">
                <!-- 营业执照 -->
                <div class="item">
                  <span style="
                      margin-right: 20px;
                      display: inline-block;
                      width: 100px;
                    ">营业执照</span>
                  <a-upload name="file" accept="image/png, image/jpeg, image/gif, image/bmp, image/tiff, image/webp" ref="BusinesslicenseEdit"
                            list-type="picture-card"
                            class="avatar-uploader" :show-upload-list="false" :action="busiURL" :headers="headers"
                            :customRequest="portraitUpload" :disabled="isEditMode && !allowImageEdit">
                    <uploadImg v-show="verifyvadata.Businesslicenseurl" @Editimg="BusinesslicenseEdit" @Uploaderror="
                      verifyvadata.Businesslicenseloading = $event
                      " :showEditicon="true" @onloadsuccsse="verifyvadata.Businesslicenseurl = $event"
                               @fileData="verifyvadata.BusinesslicenseFile = $event" ref="Businesslicense">
                    </uploadImg>
                    <div v-show="verifyvadata.Businesslicenseloading == false &&
                      !verifyvadata.Businesslicenseurl
                      ">
                      <a-icon type="plus"/>
                    </div>
                    <div v-if="verifyvadata.Businesslicenseloading == true &&
                      verifyvadata.Businesslicenseurl == ''
                      " class="example">
                      <a-spin/>
                    </div>
                  </a-upload>
                  <span v-if="verifyvadata.Humanface == false" class="erero">请先上传图片</span>
                </div>
                <!-- 身份证 反面 -->
                <div class="item">
                  <span style="
                      margin-right: 20px;
                      display: inline-block;
                      width: 100px;
                    ">法人身份证人像面</span>
                  <a-upload name="file" accept="image/png, image/jpeg, image/gif, image/bmp, image/tiff, image/webp" ref="ReverseofIDcard"
                            list-type="picture-card"
                            class="avatar-uploader" :show-upload-list="false" :action="busiURL" :headers="headers"
                            :customRequest="changeIdBack" :disabled="isEditMode && !allowImageEdit">
                    <uploadImg v-show="verifyvadata.ReverseofIDcardurl" @Editimg="ReverseofIDcardEdit" @Uploaderror="
                      verifyvadata.ReverseofIDcardloading = $event
                      " :showEditicon="true" @onloadsuccsse="verifyvadata.ReverseofIDcardurl = $event"
                               @fileData="verifyvadata.ReverseofIDcardFile = $event" ref="IdBack">
                    </uploadImg>
                    <div v-show="verifyvadata.ReverseofIDcardloading == false &&
                      !verifyvadata.ReverseofIDcardurl
                      ">
                      <a-icon type="plus"/>
                    </div>
                    <div v-if="verifyvadata.ReverseofIDcardloading &&
                      verifyvadata.ReverseofIDcardurl == ''
                      " class="example">
                      <a-spin/>
                    </div>
                  </a-upload>
                  <span v-if="verifyvadata.ReverseofIDcard == false" class="erero">请先上传照片</span>
                </div>
                <!-- 身份证 正面 -->
                <div class="item">
                  <span style="
                      margin-right: 20px;
                      display: inline-block;
                      width: 100px;
                    ">法人身份证国徽面</span>
                  <a-upload name="file" accept="image/png, image/jpeg, image/gif, image/bmp, image/tiff, image/webp" ref="Frontofidentitycard"
                            list-type="picture-card"
                            class="avatar-uploader" :show-upload-list="false" :action="busiURL" :headers="headers"
                            :customRequest="changeIdUpload" :disabled="isEditMode && !allowImageEdit">
                    <uploadImg v-show="verifyvadata.Frontofidentitycardurl" :showEditicon="true" @Uploaderror="
                      verifyvadata.Frontofidentitycardloading = $event
                      " @onloadsuccsse="
    verifyvadata.Frontofidentitycardurl = $event
    " @Editimg="FrontofidentitycardEdit" @fileData="verifyvadata.FrontofidentitycardFile = $event" ref="IdUp">
                    </uploadImg>
                    <div v-show="verifyvadata.Frontofidentitycardloading == false &&
                      !verifyvadata.Frontofidentitycardurl
                      ">
                      <a-icon type="plus"/>
                    </div>
                    <div v-if="verifyvadata.Frontofidentitycardloading == true &&
                      verifyvadata.Frontofidentitycardurl == ''
                      " class="example">
                      <a-spin/>
                    </div>
                  </a-upload>
                  <span v-if="verifyvadata.Frontofidentitycard == false" class="erero">请先上传照片</span>
                </div>
                <!-- 受益人材料证明（图片 + PDF/Word/压缩包） -->
                <div class="item">
                  <span style="
                      margin-right: 20px;
                      display: inline-block;
                      width: 100px;
                    ">受益人材料证明</span>
                  <a-upload name="file" accept="image/png, image/jpeg, image/gif, image/bmp, image/tiff, image/webp, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/zip, application/x-rar-compressed, application/x-7z-compressed" ref="BeneficiaryMaterialProof"
                            list-type="picture-card"
                            class="avatar-uploader" :show-upload-list="false" :action="busiURL" :headers="headers"
                            :customRequest="changeBeneficiaryMaterialProof" :disabled="isEditMode && !allowImageEdit">
                    <!-- 图片：缩略图展示 -->
                    <uploadImg v-if="verifyvadata.BeneficiaryMaterialProofurl && verifyvadata.BeneficiaryMaterialProofIsImage" :showEditicon="true" @Uploaderror="
                      verifyvadata.BeneficiaryMaterialProofloading = $event
                      " @onloadsuccsse="
verifyvadata.BeneficiaryMaterialProofurl = $event
" @Editimg="BeneficiaryMaterialProofEdit" @fileData="verifyvadata.BeneficiaryMaterialProofFile = $event" ref="BeneficiaryMaterialProofUpload">
                    </uploadImg>
                    <!-- 非图片：文件图标 + 文件名 -->
                    <div v-else-if="verifyvadata.BeneficiaryMaterialProofurl && !verifyvadata.BeneficiaryMaterialProofIsImage" class="file-preview-item">
                      <a-icon :type="getFileIcon(verifyvadata.BeneficiaryMaterialProofExt)" style="font-size: 28px; color: #1890ff;"/>
                      <div class="file-name" :title="verifyvadata.BeneficiaryMaterialProofName">{{ verifyvadata.BeneficiaryMaterialProofName || '已上传' }}</div>
                      <!-- 遮罩层 -->
                      <div class="file-overlay">
                        <div class="file-action" @click.stop="previewBeneficiaryFile">
                          <a-icon type="eye" />
                        </div>
                        <div v-if="isEditMode && allowImageEdit" class="file-action" @click.stop="BeneficiaryMaterialProofEdit">
                          <a-icon type="edit" />
                        </div>
                        <div class="file-action" @click.stop="removeBeneficiaryMaterialProof">
                          <a-icon type="delete" />
                        </div>
                      </div>
                    </div>
                    <!-- 未上传时显示 + -->
                    <div v-show="verifyvadata.BeneficiaryMaterialProofloading == false &&
                      !verifyvadata.BeneficiaryMaterialProofurl
                      ">
                      <a-icon type="plus"/>
                    </div>
                    <!-- 加载中 -->
                    <div v-if="verifyvadata.BeneficiaryMaterialProofloading == true &&
                      !verifyvadata.BeneficiaryMaterialProofurl
                      " class="example">
                      <a-spin/>
                    </div>
                  </a-upload>
                  <span v-if="verifyvadata.BeneficiaryMaterialProof == false" class="erero">请先上传文件</span>
                </div>
              </div>
              <!-- 提示 -->
              <div style="color: red; margin-left: 50px">
                *请确保身份证信息在有效期范围内，若证件信息过期
                需要去线下银行网点更新
              </div>
              <div v-if="isEditMode && allowImageEdit" style="color: orange; margin-left: 50px; margin-top: 10px;">
                *修改模式下，重新上传图片将替换原有图片
              </div>
            </a-form-model-item>

            <div class="legalrepresentative">
              <a-switch v-model="samePerson" default-checked style="margin-right: 15px" @change="handleSamePersonChange"/>
              法定代表人、负责人、经办人均为同一人
            </div>
            <div v-if="!samePerson">
              <!-- 实际控制人 -->
              <div class="actualcontroller">
                实际控制人 <span></span>
                <a-button class="fill" @click="fillinfo(1)">
                  点击选择法定代表人信息
                </a-button>
              </div>

              <!-- 证件类型 -->
              <a-form-model-item label="证件类型" class="controllerIdType" ref="controllerIdType"
                                 prop="controllerIdType">
                身份证
              </a-form-model-item>
              <!-- 证件号码 -->
              <a-form-model-item label="证件号码" class="controllerIdNo" ref="controllerIdNo" prop="controllerIdNo">
                <a-input v-model.trim="form.controllerIdNo" placeholder="请输入证件号码"></a-input>
              </a-form-model-item>
              <!-- 姓名 -->
              <a-form-model-item label="姓名" class="controllerIdName" ref="controllerIdName" prop="controllerIdName">
                <a-input v-model.trim="form.controllerIdName" placeholder="请输入姓名"></a-input>
              </a-form-model-item>

              <!-- 证件失效日期 -->
              <a-form-model-item label="证件失效日期" class="controllerOpto" ref="controllerOpto" prop="controllerOpto">
                <a-date-picker style="width: 200px" valueFormat="YYYY-MM-DD" ref="controllerOpto"
                               v-model.trim="form.controllerOpto">
                </a-date-picker>
                <a-checkbox style="margin-left: 50px" @change="
                  $event.target.checked
                    ? (form.controllerOpto = '9999-12-31')
                    : (form.controllerOpto = '')
                  ">
                  长期
                </a-checkbox>
              </a-form-model-item>
              <!-- 负责人 -->
              <div class="personincharge">
                负责人 <span></span>
                <a-button class="fill" @click="fillinfo(2)">
                  点击选择法定代表人信息
                </a-button>
              </div>
              <a-form-model-item label="证件类型" class="leaderIdType" ref="leaderIdType" prop="leaderIdType">
                身份证
              </a-form-model-item>
              <!-- 证件号码 -->
              <a-form-model-item label="证件号码" class="leaderIdNo" ref="leaderIdNo" prop="leaderIdNo">
                <a-input v-model.trim="form.leaderIdNo" placeholder="请输入证件号码"></a-input>
              </a-form-model-item>
              <!-- 姓名 -->
              <a-form-model-item label="姓名" class="leaderIdName" ref="leaderIdName" prop="leaderIdName">
                <a-input v-model.trim="form.leaderIdName" placeholder="请输入姓名"></a-input>
              </a-form-model-item>
              <!-- 手机号码 -->
              <a-form-model-item label="手机号" class="leaderMobile" ref="leaderMobile" prop="leaderMobile">
                <a-input v-model.trim="form.leaderMobile" placeholder="请输入手机号码"></a-input>
              </a-form-model-item>

              <!-- 证件失效日期 -->
              <a-form-model-item label="证件失效日期" class="leaderOpto" ref="leaderOpto" prop="leaderOpto">
                <a-date-picker style="width: 200px" valueFormat="YYYY-MM-DD" ref="leaderOpto"
                               v-model.trim="form.leaderOpto">
                </a-date-picker>
                <a-checkbox style="margin-left: 50px" @change="
                  $event.target.checked
                    ? (form.leaderOpto = '9999-12-31')
                    : (form.leaderOpto = '')
                  ">
                  长期
                </a-checkbox>
              </a-form-model-item>

              <!-- 经办人 -->
              <div class="agent">
                经办人 <span></span>
                <a-button class="fill" @click="fillinfo(3)">
                  点击选择法定代表人信息
                </a-button>
              </div>
              <a-form-model-item label="证件类型" class="operatorIdType" ref="operatorIdType" prop="operatorIdType">
                身份证
              </a-form-model-item>
              <!-- 证件号码 -->
              <a-form-model-item label="证件号码" class="operatorIdNo" ref="operatorIdNo" prop="operatorIdNo">
                <a-input v-model.trim="form.operatorIdNo" placeholder="请输入证件号码"></a-input>
              </a-form-model-item>
              <!-- 姓名 -->
              <a-form-model-item label="姓名" class="operatorIdName" ref="operatorIdName" prop="operatorIdName">
                <a-input v-model.trim="form.operatorIdName" placeholder="请输入姓名"></a-input>
              </a-form-model-item>
              <!-- 手机号码 -->
              <a-form-model-item label="手机号" class="operatorMobile" ref="operatorMobile" prop="operatorMobile">
                <a-input :type="'number'" v-model.trim="form.operatorMobile" placeholder="请输入手机号码"></a-input>
              </a-form-model-item>

              <!-- 证件失效日期 -->
              <a-form-model-item label="证件失效日期" class="operatorOpto" ref="operatorOpto" prop="operatorOpto">
                <a-date-picker style="width: 200px" valueFormat="YYYY-MM-DD" ref="operatorOpto"
                               v-model.trim="form.operatorOpto">
                </a-date-picker>
                <a-checkbox style="margin-left: 50px" @change="
                  $event.target.checked
                    ? (form.operatorOpto = '9999-12-31')
                    : (form.operatorOpto = '')
                  ">
                  长期
                </a-checkbox>
              </a-form-model-item>
            </div>
            <!-- 在受益人部分上方添加提示 -->
            <div class="beneficiary-tips">
              <strong>受益所有权关系类型说明：</strong>
              <ul>
                <li>1、5种类型中，应至少选择1种类型</li>
                <li>2、若选择了"股权/合伙权益 ≥25%"，则不能选择其他类型</li>
                <li>3、若选择了"日常经营管理高管"，则不能选择其他类型</li>
                <li>4、若选择了"在华最高层级高管"，则不能选择其他类型</li>
                <li>5、若选择了"收益权/表决权 ≥25%"，收益权与表决权需至少填写1个</li>
                <li>6、"收益权/表决权 ≥25%"和"实际控制"类型，可组合选择、也可单选</li>
              </ul>
            </div>

            <div class="beneficiary">
              <span>受益人信息（按《金融机构客户受益所有人识别管理办法》第八条）</span>
            </div>

            <!-- 多受益人列表 -->
            <div v-for="(beneficiary, index) in form.beneficiaryList" :key="index" class="beneficiary-item">
              <div class="beneficiary-header">
                <span>受益人 {{ index + 1 }}{{ index === 0 && isEditMode ? ' (法定代表人，不可修改)' : index === 0 ? ' (法定代表人，自动填充)' : '' }}</span>
                <a-button type="link" @click="removeBeneficiary(index)" style="margin-left: 10px; color: #ff4d4f" :disabled="index === 0">
                  <a-icon type="delete"/>
                  {{ index === 0 ? '不可删除' : '删除' }}
                </a-button>
              </div>

              <!-- 基础信息 -->
              <a-form-model-item :label="'姓名'" :prop="`beneficiaryList[${index}].beneName`" :rules="beneficiaryRules.beneName">
                <a-input v-model.trim="beneficiary.beneName" placeholder="请填写受益人姓名" :disabled="index === 0 && isEditMode"></a-input>
              </a-form-model-item>

              <a-form-model-item :label="'性别'" :prop="`beneficiaryList[${index}].beneSex`" :rules="beneficiaryRules.beneSex">
                <a-radio-group v-model.trim="beneficiary.beneSex" :disabled="index === 0 && isEditMode">
                  <a-radio v-for="item in sexlist" :key="item.value" :value="item.value">
                    {{ item.label }}
                  </a-radio>
                </a-radio-group>
              </a-form-model-item>

              <a-form-model-item :label="'国籍'" :prop="`beneficiaryList[${index}].beneNationality`" :rules="beneficiaryRules.beneNationality">
                <a-select v-model.trim="beneficiary.beneNationality" placeholder="请选择国籍" style="width: 100%" :disabled="index === 0 && isEditMode">
                  <a-select-option v-for="item in nationalitylist" :key="item.value" :value="item.value">
                    {{ item.label }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>

              <a-form-model-item :label="'证件类型'" :prop="`beneficiaryList[${index}].beneIdType`" :rules="beneficiaryRules.beneIdType">
                <a-select v-model.trim="beneficiary.beneIdType" placeholder="请选择证件类型" style="width: 100%" :disabled="index === 0 && isEditMode">
                  <a-select-option value="1">身份证</a-select-option>
                  <a-select-option value="7">护照</a-select-option>
                </a-select>
              </a-form-model-item>

              <a-form-model-item :label="'证件号码'" :prop="`beneficiaryList[${index}].beneIdNo`" :rules="beneficiaryRules.beneIdNo">
                <a-input v-model.trim="beneficiary.beneIdNo" @change="onBeneficiaryIdNoChange(index)" placeholder="请输入证件号码" :disabled="index === 0 && isEditMode"></a-input>
              </a-form-model-item>

              <a-form-model-item :label="'证件有效期'" class="beneOpto" :prop="`beneficiaryList[${index}].beneOpto`" :rules="beneficiaryRules.beneOpto">
                <a-date-picker style="width: 200px" valueFormat="YYYY-MM-DD" v-model.trim="beneficiary.beneOpto" :disabled="index === 0 && isEditMode">
                </a-date-picker>

              </a-form-model-item>

              <a-form-model-item :label="'地址'" :prop="`beneficiaryList[${index}].beneAddress`" :rules="beneficiaryRules.beneAddress">
                <a-input v-model.trim="beneficiary.beneAddress" placeholder="请输入受益人地址" :disabled="index === 0 && isEditMode"></a-input>
              </a-form-model-item>

              <a-form-model-item :label="'联系电话'" :prop="`beneficiaryList[${index}].beneMobile`" :rules="beneficiaryRules.beneMobile">
                <a-input v-model.trim="beneficiary.beneMobile" placeholder="请输入联系电话" :disabled="index === 0 && isEditMode" :maxLength="11"></a-input>
              </a-form-model-item>

              <a-form-model-item :label="'出生日期'" :prop="`beneficiaryList[${index}].beneBirthday`" :rules="beneficiaryRules.beneBirthday">
                <a-date-picker style="width: 100%" valueFormat="YYYY-MM-DD" v-model.trim="beneficiary.beneBirthday" :disabled="index === 0 && isEditMode">
                </a-date-picker>
              </a-form-model-item>

              <a-form-model-item :label="'受益人认定类型'" :prop="`beneficiaryList[${index}].identification_types`"
                                 :rules="beneficiaryRules.identification_types">
                <a-checkbox-group v-model="beneficiary.identification_types" @change="onBeneficiaryTypeChange(index)" :disabled="index === 0 && isEditMode">
                  <a-checkbox value="equity">股权/合伙权益 ≥ 25%</a-checkbox>
                  <a-checkbox value="profitVote">收益权/表决权 ≥ 25%</a-checkbox>
                  <a-checkbox value="control">实际控制</a-checkbox>
                  <a-checkbox value="seniorMgr">日常经营管理高管</a-checkbox>
                  <a-checkbox value="foreignBranch">在华最高层级高管</a-checkbox>
                </a-checkbox-group>
                <div v-if="beneficiary.identification_types && beneficiary.identification_types.length > 0"
                     style="color: #666; font-size: 12px; margin-top: 5px;">
                  * 已选择 {{ beneficiary.identification_types.length }} 种类型
                </div>
              </a-form-model-item>

              <!-- 股权类型字段 -->
              <div v-if="beneficiary.identification_types.includes('equity')" class="type-fields">
                <div class="type-fields-header">股权信息</div>
                <a-row :gutter="24">
                  <a-col :span="8">
                    <a-form-model-item
                        label="持股比例(%)"
                        :prop="`beneficiaryList[${index}].actHdRat`"
                        :rules="beneficiaryRules.actHdRat"
                        class="compact-form-item">
                      <a-input-number
                          v-model.number="beneficiary.actHdRat"
                          :min="25"
                          :max="100"
                          :precision="4"
                          style="width: 100%"
                          placeholder="请输入持股比例"
                      />
                    </a-form-model-item>
                  </a-col>
                  <a-col :span="8">
                    <a-form-model-item
                        label="形成日期"
                        :prop="`beneficiaryList[${index}].shareRatioStartDate`"
                        :rules="beneficiaryRules.shareRatioStartDate"
                        class="compact-form-item">
                      <a-date-picker
                          v-model="beneficiary.shareRatioStartDate"
                          valueFormat="YYYY-MM-DD"
                          placeholder="请选择形成日期"
                          style="width: 100%"
                      />
                    </a-form-model-item>
                  </a-col>
                  <a-col :span="8">
                    <a-form-model-item
                        label="终止日期"
                        :prop="`beneficiaryList[${index}].shareRatioEndDate`"
                        :rules="beneficiaryRules.shareRatioEndDate"
                        class="compact-form-item">
                      <a-date-picker
                          v-model="beneficiary.shareRatioEndDate"
                          valueFormat="YYYY-MM-DD"
                          placeholder="请选择终止日期"
                          style="width: 100%"
                      />
                    </a-form-model-item>
                  </a-col>
                </a-row>
              </div>

              <!-- 收益权/表决权类型字段 -->
              <div style="padding: 20px;" v-if="beneficiary.identification_types.includes('profitVote')" class="type-fields">
                <div class="type-fields-header">收益权/表决权信息</div>
                <a-row :gutter="24">
                  <a-col :span="8">
                    <a-form-model-item
                        label="收益权比例(%)"
                        :prop="`beneficiaryList[${index}].actOwnerProfitRatio`"
                        :rules="beneficiaryRules.actOwnerProfitRatio"
                        class="compact-form-item">
                      <a-input-number
                          v-model.number="beneficiary.actOwnerProfitRatio"
                          :min="25"
                          :max="100"
                          :precision="4"
                          style="width: 100%"
                          placeholder="请输入收益权比例"
                      />
                    </a-form-model-item>
                  </a-col>

                  <a-col :span="8">
                    <a-form-model-item
                        label="收益权开始日期"
                        :prop="`beneficiaryList[${index}].profitRatioStartDate`"
                        :rules="beneficiaryRules.profitRatioStartDate"
                        class="compact-form-item">
                      <a-date-picker
                          v-model="beneficiary.profitRatioStartDate"
                          valueFormat="YYYY-MM-DD"
                          placeholder="请选择收益权开始日期"
                          style="width: 100%"
                      />
                    </a-form-model-item>
                  </a-col>

                  <a-col :span="8">
                    <a-form-model-item
                        label="收益权结束日期"
                        :prop="`beneficiaryList[${index}].profitRatioEndDate`"
                        :rules="beneficiaryRules.profitRatioEndDate"
                        class="compact-form-item">
                      <a-date-picker
                          v-model="beneficiary.profitRatioEndDate"
                          valueFormat="YYYY-MM-DD"
                          placeholder="请选择收益权结束日期"
                          style="width: 100%"
                      />
                    </a-form-model-item>
                  </a-col>
                </a-row>

                <a-row :gutter="24">
                  <a-col :span="8">
                    <a-form-model-item
                        label="表决权比例(%)"
                        :prop="`beneficiaryList[${index}].actOwnerProfitRatioVote`"
                        :rules="beneficiaryRules.actOwnerProfitRatioVote"
                        class="compact-form-item">
                      <a-input-number
                          v-model.number="beneficiary.actOwnerProfitRatioVote"
                          :min="25"
                          :max="100"
                          :precision="4"
                          style="width: 100%"
                          placeholder="请输入表决权比例"
                      />
                    </a-form-model-item>
                  </a-col>

                  <a-col :span="8">
                    <a-form-model-item
                        label="表决权开始日期"
                        :prop="`beneficiaryList[${index}].profitRatioVoteStartDate`"
                        :rules="beneficiaryRules.profitRatioVoteStartDate"
                        class="compact-form-item">
                      <a-date-picker
                          v-model="beneficiary.profitRatioVoteStartDate"
                          valueFormat="YYYY-MM-DD"
                          placeholder="请选择表决权开始日期"
                          style="width: 100%"
                      />
                    </a-form-model-item>
                  </a-col>
                  <a-col :span="8">
                    <a-form-model-item
                        label="表决权结束日期"
                        :prop="`beneficiaryList[${index}].profitRatioVoteEndDate`"
                        :rules="beneficiaryRules.profitRatioVoteEndDate"
                        class="compact-form-item">
                      <a-date-picker
                          v-model="beneficiary.profitRatioVoteEndDate"
                          valueFormat="YYYY-MM-DD"
                          placeholder="请选择表决权结束日期"
                          style="width: 100%"
                      />
                    </a-form-model-item>
                  </a-col>
                </a-row>
              </div>

              <!-- 实际控制类型字段 -->
              <div v-if="beneficiary.identification_types.includes('control')" class="type-fields">
                <div class="type-fields-header">实际控制信息</div>
                <a-row :gutter="24">
                  <a-col :span="8">
                    <a-form-model-item
                        label="控制类型"
                        :prop="`beneficiaryList[${index}].actCtrlCpny`"
                        :rules="beneficiaryRules.actCtrlCpny"
                        class="compact-form-item">
                      <a-select
                          v-model.trim="beneficiary.actCtrlCpny"
                          :default-value="2"
                          placeholder="请选择控制类型"
                          style="width: 100%"
                      >
                        <a-select-option value="2">协议约定形式</a-select-option>
                        <a-select-option value="3">其他形式</a-select-option>
                      </a-select>
                    </a-form-model-item>
                  </a-col>

                  <a-col :span="8">
                    <a-form-model-item
                        label="控制开始日期"
                        :prop="`beneficiaryList[${index}].obtainActDate`"
                        :rules="beneficiaryRules.obtainActDate"
                        class="compact-form-item">
                      <a-date-picker
                          v-model="beneficiary.obtainActDate"
                          valueFormat="YYYY-MM-DD"
                          placeholder="请选择控制开始日期"
                          style="width: 100%"
                      />
                    </a-form-model-item>
                  </a-col>
                  <a-col :span="8">
                    <a-form-model-item
                        label="控制结束日期"
                        :prop="`beneficiaryList[${index}].terminationActDate`"
                        :rules="beneficiaryRules.terminationActDate"
                        class="compact-form-item">
                      <a-date-picker
                          v-model="beneficiary.terminationActDate"
                          valueFormat="YYYY-MM-DD"
                          placeholder="请选择控制结束日期"
                          style="width: 100%"
                      />
                    </a-form-model-item>
                  </a-col>
                </a-row>

                <a-row :gutter="24">


                  <a-col :span="8">
                    <a-form-model-item
                        label="控制内容"
                        :prop="`beneficiaryList[${index}].actCtrlType`"
                        :rules="beneficiaryRules.actCtrlType"
                        class="compact-form-item">
                      <a-select
                          v-model.trim="beneficiary.actCtrlType"
                          placeholder="请选择控制内容"
                          style="width: 100%"
                      >
                        <a-select-option value="0">决定法定代表人、董事、监事、高级管理人员的任免</a-select-option>
                        <a-select-option value="1">决定公司或者合伙企业重大经营、管理决策的制定或者执行</a-select-option>
                        <a-select-option value="2">决定公司公司或者合伙企业的财务收支</a-select-option>
                        <a-select-option value="3">长期实际支配使用公司公司或者合伙企业重要资产或者主要资金</a-select-option>
                      </a-select>
                    </a-form-model-item>
                  </a-col>

                  <a-col :span="8">
                    <a-form-model-item
                        label="其他形式内容"
                        :prop="`beneficiaryList[${index}].actOtherForms`"
                        :rules="beneficiaryRules.actOtherForms"
                        class="compact-form-item">
                      <a-textarea
                          v-model.trim="beneficiary.actOtherForms"
                          :rows="2"
                          placeholder="请描述其他形式内容"
                          style="width: 100%"
                      />
                    </a-form-model-item>
                  </a-col>
                  <a-col :span="8">
                    <a-form-model-item
                        label="上层实体是否存在"
                        class="compact-form-item">
                      <a-switch v-model="beneficiary.actConUpperMarket" @change="onChangeActConUpperMarket"/>
                    </a-form-model-item>
                  </a-col>
                </a-row>

                <a-row v-if="beneficiary.actConUpperMarket" :gutter="16">
                  <a-col :span="8">
                    <a-form-model-item
                        label="上层实体名称"
                        :prop="`beneficiaryList[${index}].actConUpperEntName`"
                        :rules="beneficiaryRules?.actConUpperEntName"
                        class="compact-form-item">
                      <a-input
                          v-model.trim="beneficiary.actConUpperEntName"
                          placeholder="请输入上层备案主体名称"
                          style="width: 100%"
                      />
                    </a-form-model-item>
                  </a-col>
                  <a-col :span="8">
                    <a-form-model-item
                        label="统一社会信用代码"
                        :prop="`beneficiaryList[${index}].actConUniScid`"
                        :rules="beneficiaryRules?.actConUniScid"
                        class="compact-form-item">
                      <a-input
                          v-model.trim="beneficiary.actConUniScid"
                          :maxLength="18"
                          placeholder="请输入统一社会信用代码"
                          style="width: 100%"
                      />
                    </a-form-model-item>
                  </a-col>
                </a-row>
              </div>

              <!-- 日常经营管理高管类型字段 -->
              <div v-if="beneficiary.identification_types.includes('seniorMgr')" class="type-fields">
                <div class="type-fields-header">日常经营管理高管信息</div>
                <a-row :gutter="24">
                  <a-col :span="8">
                    <a-form-model-item
                        label="职位"
                        :prop="`beneficiaryList[${index}].seniorMgrPos`"
                        :rules="beneficiaryRules.seniorMgrPos"
                        class="compact-form-item">
                      <a-select
                          v-model.trim="beneficiary.seniorMgrPos"
                          placeholder="请选择职位"
                          style="width: 100%">
                        <a-select-option value="10">法定代表人</a-select-option>
                        <a-select-option value="11">董事长</a-select-option>
                        <a-select-option value="12">经理</a-select-option>
                        <a-select-option value="13">董事</a-select-option>
                        <a-select-option value="14">执行合伙事务的自然人</a-select-option>
                        <a-select-option value="15">其他人员</a-select-option>
                      </a-select>
                    </a-form-model-item>
                  </a-col>
                  <a-col :span="16">
                    <a-form-model-item
                        label="其他职位"
                        :prop="`beneficiaryList[${index}].actDailyMgmtPostOther`"
                        :rules="beneficiaryRules.actDailyMgmtPostOther"
                        class="compact-form-item">
                      <a-textarea
                          v-model.trim="beneficiary.actDailyMgmtPostOther"
                          :rows="2"
                          placeholder="如有其他职位请在此填写"
                          style="width: 100%"
                      />
                    </a-form-model-item>
                  </a-col>
                </a-row>
              </div>

              <!-- 在华最高层级高管类型字段 -->
              <div v-if="beneficiary.identification_types.includes('foreignBranch')" class="type-fields">
                <div class="type-fields-header">在华最高层级高管信息</div>
                <a-row :gutter="24">
                  <a-col :span="8">
                    <a-form-model-item
                        label="在华职位"
                        :prop="`beneficiaryList[${index}].seniorMgrPosCn`"
                        :rules="beneficiaryRules.seniorMgrPosCn"
                        class="compact-form-item">
                      <a-select
                          v-model.trim="beneficiary.seniorMgrPosCn"
                          placeholder="请选择在华职位"
                          style="width: 100%">
                        <a-select-option value="0">分支机构负责人</a-select-option>
                        <a-select-option value="1">其他高级管理人员</a-select-option>
                      </a-select>
                    </a-form-model-item>
                  </a-col>
                  <a-col :span="8">
                    <a-form-model-item
                        label="其他职位"
                        :prop="`beneficiaryList[${index}].ownerRightMgmtPostOther`"
                        :rules="beneficiaryRules.ownerRightMgmtPostOther"
                        class="compact-form-item">
                      <a-textarea
                          v-model.trim="beneficiary.ownerRightMgmtPostOther"
                          :rows="2"
                          placeholder="请填写其他职位信息"
                          style="width: 100%"
                      />
                    </a-form-model-item>
                  </a-col>
                  <a-col :span="8">
                    <a-form-model-item
                        label="开始日期"
                        :prop="`beneficiaryList[${index}].benStartDate`"
                        :rules="beneficiaryRules.benStartDate"
                        class="compact-form-item">
                      <a-date-picker
                          v-model="beneficiary.benStartDate"
                          valueFormat="YYYY-MM-DD"
                          placeholder="请选择开始日期"
                          style="width: 100%"
                      />
                    </a-form-model-item>
                  </a-col>
                </a-row>

                <a-row :gutter="24">
                  <a-col :span="8">
                    <a-form-model-item
                        label="结束日期"
                        :prop="`beneficiaryList[${index}].benEndDate`"
                        :rules="beneficiaryRules.benEndDate"
                        class="compact-form-item">
                      <a-date-picker
                          v-model="beneficiary.benEndDate"
                          valueFormat="YYYY-MM-DD"
                          placeholder="请选择结束日期"
                          style="width: 100%"
                      />
                    </a-form-model-item>
                  </a-col>
                </a-row>
              </div>
            </div>




            <div style=" margin-top: 25px;margin-bottom: 25px">
              <a-button type="link" @click="addBeneficiary" style="margin-left: 10px">
                <a-icon type="plus"/>
                添加受益人
              </a-button>
            </div>

            <div class="legalrepresentative">短信认证</div>
            <!-- 手机号 -->
            <a-form-model-item label="手机号" class="mobile" ref="mobile" prop="mobile">
              <a-input :type="'number'" v-model.trim="form.mobile" placeholder="请输入手机号" :disabled="mobileDisabled"></a-input>
            </a-form-model-item>
            <!-- 验证码 -->
            <a-form-model-item label="验证码" class="code" ref="code" prop="verifyCode">
              <a-input v-model.trim="form.verifyCode" placeholder="请输入验证码">
                <CountdownBtn slot="suffix" :wait-time="60" :error-wait-time="10" :send-call="sendcode"></CountdownBtn>
              </a-input>
            </a-form-model-item>
          </a-form-model>
          <QRConfirm :url="qrConfirmUrl" :display.sync=qrConfirmShow
                     :busi_intro="isEditMode ? '企业开户信息变更' : '企业开户'"
                     :username="this.form.accountName" @close="qrConfirmShow== false"></QRConfirm>
        </div>
      </div>
    </a-card>

    <!-- 确认模态框 -->
    <a-modal :title="isEditMode ? '修改确认' : '开户确认'" class="confirmloading" :maskClosable="true"
             @cancel="confirmshow = false" :centered="true" :visible="confirmshow">
      <div class="text">{{ isEditMode ? '是否确认修改？' : '是否确认开户？' }}</div>
      <template v-slot:footer>
        <div class="custom-footer">
          <a-button type="primary" @click="ConfirmSave">保存</a-button>
          <a-button @click="confirmshow = false">取消</a-button>
          <a-button @click="ConfirmQRPush">邀请扫码办理</a-button>
        </div>
      </template>
    </a-modal>

    <!-- 取消模态框 -->
    <a-modal :title="isEditMode ? '取消修改' : '取消开户'" class="confirmloading" :maskClosable="true"
             @cancel="cancelshow = false" :centered="true" :visible="cancelshow">
      <div class="canceltext">
        {{ isEditMode ? '是否取消修改？' : '是否取消开户？取消后该页面信息将不会被保存' }}
      </div>
      <template v-slot:footer>
        <div class="custom-footer">
          <a-button type="primary" @click="
            cancelshow = false
          $router.go(-1)
            ">确认
          </a-button>
          <a-button @click="cancelshow = false">取消</a-button>
        </div>
      </template>
    </a-modal>
    <!-- 受益人文件预览 -->
    <a-modal :visible="beneficiaryFilePreviewVisible" :footer="null" @cancel="beneficiaryFilePreviewVisible = false" width="800px">
      <div style="text-align: center; padding: 40px;">
        <a-icon :type="getFileIcon(beneficiaryFilePreviewExt)" style="font-size: 64px; color: #1890ff;"/>
        <p style="color: #666; margin-top: 16px;">{{ beneficiaryFilePreviewName || '文件预览' }}</p>
        <a-button type="primary" @click="downloadBeneficiaryFile" style="margin-top: 16px;">
          <a-icon type="download"/> 下载文件
        </a-button>
      </div>
    </a-modal>
    <!-- 受益人信息查询结果模态框 -->


    <a-drawer
        title="受益人信息查询结果"
        placement="right"
        width="45%"
        :visible="beneficiaryDrawerVisible"
        @close="beneficiaryDrawerVisible = false"

    >
      <a-spin :spinning="beneficiaryLoading">
        <div v-if="beneficiaryData" class="beneficiary-result">
          <!-- 公司信息 -->
          <a-divider>公司信息</a-divider>
          <a-descriptions :column="2" bordered size="small">
            <a-descriptions-item label="公司名称">{{ beneficiaryData.qccCompanyInfo?.name || '-' }}</a-descriptions-item>
            <a-descriptions-item label="统一社会信用代码">{{ beneficiaryData.qccCompanyInfo?.creditCode || '-' }}</a-descriptions-item>
            <a-descriptions-item label="登记状态">{{ beneficiaryData.qccCompanyInfo?.status || '-' }}</a-descriptions-item>
            <a-descriptions-item label="注册资本">{{ beneficiaryData.qccCompanyInfo?.registCapi || '-' }}</a-descriptions-item>
            <a-descriptions-item label="实缴资本">{{ beneficiaryData.qccCompanyInfo?.recCap || '-' }}</a-descriptions-item>
            <a-descriptions-item label="法人代表">{{ beneficiaryData.qccCompanyInfo?.oper || '-' }}</a-descriptions-item>
            <a-descriptions-item label="经营状态">{{ beneficiaryData.qccCompanyInfo?.shortStatus || '-' }}</a-descriptions-item>
            <a-descriptions-item label="员工人数">{{ beneficiaryData.qccCompanyInfo?.staffs || '-' }}</a-descriptions-item>
            <a-descriptions-item label="地址" :span="2">{{ beneficiaryData.qccCompanyInfo?.address || '-' }}</a-descriptions-item>
            <a-descriptions-item label="经营范围" :span="2">{{ beneficiaryData.qccCompanyInfo?.scope || '-' }}</a-descriptions-item>
          </a-descriptions>

          <!-- 25%以上股权信息 -->
          <a-divider v-if="beneficiaryData.qccBreakThroughList && beneficiaryData.qccBreakThroughList.length > 0">25%以上股权</a-divider>
          <div v-for="(item, index) in beneficiaryData.qccBreakThroughList" :key="'breakthrough-'+index" class="beneficiary-section">
            <a-descriptions :column="2" bordered size="small">
              <a-descriptions-item label="姓名">{{ item.name || '-' }}</a-descriptions-item>
              <a-descriptions-item label="持股类型">{{ item.benifitType || '-' }}</a-descriptions-item>
              <a-descriptions-item label="总持股比例">{{ item.totalStockPercent || '-' }}</a-descriptions-item>
              <a-descriptions-item label="任职类型">{{ item.position || '-' }}</a-descriptions-item>
              <a-descriptions-item label="形成日期">{{ item.uboDate || '-' }}</a-descriptions-item>
            </a-descriptions>
            <!-- 股权明细 -->
            <div v-if="item.qccBreakThroughDetailList && item.qccBreakThroughDetailList.length > 0" style="margin-top: 10px;">
              <a-table :data-source="item.qccBreakThroughDetailList" :pagination="false" size="small" bordered>
                <a-table-column title="出资类型" data-index="capitalType" key="capitalType"></a-table-column>
                <a-table-column title="层级关系" data-index="path" key="path"></a-table-column>
                <a-table-column title="持股比例" data-index="stockPercent" key="stockPercent"></a-table-column>
                <a-table-column title="层级" data-index="level" key="level"></a-table-column>
                <a-table-column title="持股方式" data-index="stockType" key="stockType"></a-table-column>
                <a-table-column title="认缴出资额" data-index="shouldCapi" key="shouldCapi"></a-table-column>
              </a-table>
            </div>
          </div>

          <!-- 25%以上表决权、收益权 -->
          <a-divider v-if="beneficiaryData.qccCriterion2ndInfoList && beneficiaryData.qccCriterion2ndInfoList.length > 0">25%以上表决权/收益权</a-divider>
          <a-table
              v-if="beneficiaryData.qccCriterion2ndInfoList && beneficiaryData.qccCriterion2ndInfoList.length > 0"
              :data-source="beneficiaryData.qccCriterion2ndInfoList"
              :pagination="false"
              size="small"
              bordered
          >
            <a-table-column title="姓名" data-index="name" key="name"></a-table-column>
            <a-table-column title="直接持股比例" data-index="percent" key="percent"></a-table-column>
            <a-table-column title="表决权比例" data-index="votingPercent" key="votingPercent"></a-table-column>
            <a-table-column title="总持股比例" data-index="totalStockPercent" key="totalStockPercent"></a-table-column>
            <a-table-column title="形成日期" data-index="uboDate" key="uboDate"></a-table-column>
          </a-table>

          <!-- 控制/影响自然人 -->
          <a-divider v-if="beneficiaryData.qccCriterion3rdInfoList && beneficiaryData.qccCriterion3rdInfoList.length > 0">控制/影响自然人</a-divider>
          <a-table
              v-if="beneficiaryData.qccCriterion3rdInfoList && beneficiaryData.qccCriterion3rdInfoList.length > 0"
              :data-source="beneficiaryData.qccCriterion3rdInfoList"
              :pagination="false"
              size="small"
              bordered
          >
            <a-table-column title="姓名" data-index="name" key="name"></a-table-column>
            <a-table-column title="任职类型" data-index="position" key="position"></a-table-column>
            <a-table-column title="形成日期" data-index="uboDate" key="uboDate"></a-table-column>
          </a-table>

          <!-- 日常经营管理人员 -->
          <a-divider v-if="beneficiaryData.qccManagerList && beneficiaryData.qccManagerList.length > 0">日常经营管理人员</a-divider>
          <a-table
              v-if="beneficiaryData.qccManagerList && beneficiaryData.qccManagerList.length > 0"
              :data-source="beneficiaryData.qccManagerList"
              :pagination="false"
              size="small"
              bordered
          >
            <a-table-column title="姓名" data-index="name" key="name"></a-table-column>
            <a-table-column title="任职类型" data-index="position" key="position"></a-table-column>
          </a-table>

          <!-- 一键填充和复制按钮 -->
          <div style="margin-top: 20px; text-align: center;">
            <a-button type="primary" @click="fillBeneficiaryInfo">一键填充受益人信息</a-button>
            <a-button style="margin-left: 10px;" @click="copyBeneficiaryText">一键复制成文本</a-button>
          </div>
        </div>
        <a-empty v-else-if="!beneficiaryLoading" description="暂无查询结果"/>
      </a-spin>
    </a-drawer>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import {BizDict, BizDictCascade} from '@/utils/bizDict/kvMap.js'
import axios from 'axios'
import urlConfig from '@/utils/urlConfig'
import uploadImg from '@/components/uploadImg/index.vue'
import CustChooseDialog from '@/view/components/ChooseDialog/CustChooseDialog.vue'
import {dict_rawdata_cascade} from '@/utils/bizDict/rawdata'
import {contractDocTemp} from '@/utils/contractDocTemp'
import CountdownBtn from '@/view/components/CountdownBtn.vue'
import QRConfirm from "@/view/components/QRConfirm.vue";
import BankSearch from "@/view/components/BankSearch.vue";

const getToken = () => sessionStorage.getItem('token')

// 验证函数
const validateBrackets = (rule, value, callback) => {
  const regex = /[\(\)]/;
  if (regex.test(value)) {
    callback(new Error('文本中包含英文括号!'));
  } else {
    callback();
  }
};

const validateIDCard = (rule, value, callback) => {
  let custNumReg = /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
  if (value === '') {
    callback(new Error('请输入证件号码'))
  } else if (!custNumReg.test(value)) {
    callback(new Error('身份证不符合规范'))
  } else {
    let lastStr = value.substring(value.length - 1)
    if (lastStr === 'x') {
      callback(new Error('身份证最后一位字母要求大写!'))
    } else {
      callback()
    }
  }
}

// 受益人默认模板（符合新法规结构）
const defaultBeneficiary = (isFirst = false) => ({
  // 基础信息
  beneName: '',
  beneSex: '1',
  beneNationality: '156',
  beneIdType: '1', // 证件类型
  beneIdNo: '',
  beneOpto: '',
  beneAddress: '',
  beneMobile: '',
  beneBirthday: null,

  // 认定类型
  identification_types: [],

  // 股权类型字段
  actCtrl: '',
  actHdRat: null,
  shareRatioStartDate: null,
  shareRatioEndDate: null,

  // 收益权/表决权类型字段
  priBenfit: '',
  actOwnerProfitRatio: null,
  actOwnerProfitRatioVote: null,
  profitRatioStartDate: null,
  profitRatioEndDate: null,
  profitRatioVoteStartDate: null,
  profitRatioVoteEndDate: null,

  // 实际控制类型字段
  actCtrlCpny: '',
  actCtrlType: '',
  actOtherForms: '',
  obtainActDate: null,
  terminationActDate: null,

  actConUpperMarket: false,
  actConUpperEntName: '',
  actConUniScid: '',

  // 日常经营管理高管类型字段
  seniorMgr: '',
  seniorMgrPos: '',
  actDailyMgmtPostOther: '',

  // 在华最高层级高管类型字段
  seniorMgrCn: '',
  seniorMgrPosCn: '',
  ownerRightMgmtPostOther: '',
  benStartDate: null,
  benEndDate: null,
})

export default {
  components: {
    BankSearch,
    QRConfirm,
    CountdownBtn,
    CustChooseDialog,
    uploadImg,
  },
  data() {
    return {
      isEditMode: false, // 是否编辑模式
      allowImageEdit: false, // 编辑模式下是否允许修改图片
      qrConfirmUrl: "",
      qrConfirmShow: false,
      mobileDisabled: false,
      checkBoxValue: false,
      id_checked: false,
      samePerson: true,
      confirmshow: false,
      cancelshow: false,

      // 受益人查询相关
      beneficiaryDrawerVisible: false,
      beneficiaryLoading: false,
      beneficiaryData: null,
      // 受益人文件预览
      beneficiaryFilePreviewVisible: false,
      beneficiaryFilePreviewExt: '',
      beneficiaryFilePreviewName: '',
      latitude: '',
      busiURL: urlConfig.busiURL + '/file/manager/upload',
      longitude: '',
      labelCol: {span: 3},
      Userauthorization: false,
      industrylist: BizDictCascade.WorkCorpIndusCD,
      wrapperCol: {span: 21},
      ethnicitylist: BizDict.RaceCd,
      sexlist: BizDict.gender,
      OcpCdlist: BizDictCascade.OcpCd,
      treeData: [],
      loading: false,
      headers: {
        token: getToken(),
      },
      fileList: [
        {
          fileNo: '',
          fileType: '01',
          page: '1',
          channel_file_no: '',
        },
        {
          fileNo: '',
          fileType: '02',
          page: '2',
          channel_file_no: '',
        },
        {
          fileNo: '',
          fileType: '12',
          page: '3',
          channel_file_no: '',
        },
        {
          fileNo: '',
          fileType: '05',
          page: '4',
          channel_file_no: '',
        },
      ],
      verifyvadata: {
        Frontofidentitycard: true,
        Frontofidentitycardurl: '',
        FrontofidentitycardFile: '',
        Frontofidentitycardloading: false,
        ReverseofIDcard: true,
        ReverseofIDcardurl: '',
        ReverseofIDcardFile: '',
        ReverseofIDcardloading: false,
        Businesslicense: true,
        Businesslicenseurl: '',
        BusinesslicenseFile: '',
        Businesslicenseloading: false,
        BeneficiaryMaterialProof: true,
        BeneficiaryMaterialProofurl: '',
        BeneficiaryMaterialProofFile: '',
        BeneficiaryMaterialProofloading: false,
        BeneficiaryMaterialProofIsImage: true,
        BeneficiaryMaterialProofExt: '',
        BeneficiaryMaterialProofName: '',
      },
      custnumlist: [],
      account_namelist: [],
      nationalitylist: BizDict.NtntyCd,
      Upimgshow: '',
      getUpFrontofidentitycard: '',
      getUplloading: false,
      Backimgshow: '',
      getBackFile: '',
      getBackloading: false,
      portraitshow: '',
      portraitFile: '',
      portraitloading: false,
      show: true,
      Countdown: 60,
      isShowBankChoose: false,

      // 受益人验证规则（符合法规要求）
      beneficiaryRules: {
        // 基础信息
        beneName: [
          {required: true, message: '请输入受益人姓名', trigger: 'change'},
        ],
        beneSex: [
          {required: true, message: '请选择受益人性别', trigger: 'change'},
        ],
        beneNationality: [
          {required: true, message: '请选择受益人国籍', trigger: 'change'},
        ],
        beneIdType: [
          {required: true, message: '请选择证件类型', trigger: 'change'},
        ],
        beneIdNo: [
          {required: true, message: '请输入证件号码', trigger: 'blur'},
        ],
        beneOpto: [
          {required: true, message: '请输入证件有效期', trigger: 'change'},
        ],
        beneAddress: [
          {required: true, message: '请输入受益人地址', trigger: 'blur'},
        ],
        beneMobile: [
          {required: true, message: '请输入证件有效', trigger: 'change'},
          {
            pattern: /^1[3-9]\d{9}$/,
            message: '请输入有效的手机号码',
            trigger: 'blur',
          },
        ],
        beneBirthday: [
          {required: true, message: '请输入出生日期', trigger: 'change'},
        ],
        // 认定类型验证（至少选择一种）
        identification_types: [
          {
            validator: (rule, value, callback) => {
              if (!value || value.length === 0) {
                callback(new Error('至少选择一种认定类型'));
              } else {
                const hasEquity = value.includes('equity');
                const hasSeniorMgr = value.includes('seniorMgr');
                const hasForeignBranch = value.includes('foreignBranch');
                const hasProfitVote = value.includes('profitVote');
                const hasControl = value.includes('control');

                // 规则2-4：股权、日常经营管理、在华最高层级高管必须单选
                if (hasEquity && (hasSeniorMgr || hasForeignBranch || hasProfitVote || hasControl)) {
                  callback(new Error('选择股权/合伙权益类型时，不能选择其他类型'));
                } else if (hasSeniorMgr && (hasEquity || hasForeignBranch || hasProfitVote || hasControl)) {
                  callback(new Error('选择日常经营管理类型时，不能选择其他类型'));
                } else if (hasForeignBranch && (hasEquity || hasSeniorMgr || hasProfitVote || hasControl)) {
                  callback(new Error('选择在华最高层级高管类型时，不能选择其他类型'));
                } else {
                  callback();
                }
              }
            },
            trigger: 'change'
          }
        ],
        // 收益权/表决权相关验证
        actOwnerProfitRatio: [
          {
            validator: (rule, value, callback) => {
              const parentIndex = parseInt(rule.field.match(/\[(\d+)\]/)[1])
              const beneficiary = this.form.beneficiaryList[parentIndex]

              if (beneficiary.identification_types.includes('profitVote')) {
                const hasProfitRatio = beneficiary.actOwnerProfitRatio !== null && beneficiary.actOwnerProfitRatio !== '';
                const hasVoteRatio = beneficiary.actOwnerProfitRatioVote !== null && beneficiary.actOwnerProfitRatioVote !== '';

                // 规则5：收益权和表决权至少填写一个
                if (!hasProfitRatio && !hasVoteRatio) {
                  callback(new Error('收益权或表决权比例至少填写一项，且比例≥25%'));
                } else if (hasProfitRatio && (beneficiary.actOwnerProfitRatio < 25 || beneficiary.actOwnerProfitRatio > 100)) {
                  callback(new Error('收益权比例应在25%-100%之间'));
                } else {
                  callback();
                }
              } else {
                callback();
              }
            },
            trigger: 'blur'
          }
        ],

        actOwnerProfitRatioVote: [
          {
            validator: (rule, value, callback) => {
              const parentIndex = parseInt(rule.field.match(/\[(\d+)\]/)[1])
              const beneficiary = this.form.beneficiaryList[parentIndex]

              if (beneficiary.identification_types.includes('profitVote')) {
                const hasProfitRatio = beneficiary.actOwnerProfitRatio !== null && beneficiary.actOwnerProfitRatio !== '';
                const hasVoteRatio = beneficiary.actOwnerProfitRatioVote !== null && beneficiary.actOwnerProfitRatioVote !== '';

                // 规则5：收益权和表决权至少填写一个
                if (!hasProfitRatio && !hasVoteRatio) {
                  callback(new Error('收益权或表决权比例至少填写一项，且比例≥25%'));
                } else if (hasVoteRatio && (beneficiary.actOwnerProfitRatioVote < 25 || beneficiary.actOwnerProfitRatioVote > 100)) {
                  callback(new Error('表决权比例应在25%-100%之间'));
                } else {
                  callback();
                }
              } else {
                callback();
              }
            },
            trigger: 'blur'
          }
        ],

        // 股权类型
        actHdRat: [
          {required: true, message: '请输入持股比例', trigger: 'blur'},
          {
            validator: (rule, value, callback) => {
              if (value === null || value === undefined || value === '') {
                callback(new Error('请输入持股比例'));
              } else if (typeof value === 'number' && (value < 25 || value > 100)) {
                callback(new Error('持股比例应在25%-100%之间'));
              } else {
                callback();
              }
            },
            trigger: 'blur'
          }
        ],
        shareRatioStartDate: [
          {required: true, message: '请选择形成日期', trigger: 'change'},
        ],
        shareRatioEndDate: [
          {required: true, message: '请选择终止日期', trigger: 'change'},
        ],

        profitRatioStartDate: [
          {required: true, message: '请选择收益权开始日期', trigger: 'change'},
        ],
        profitRatioEndDate: [
          {required: true, message: '请选择收益权结束日期', trigger: 'change'},
        ],
        profitRatioVoteStartDate: [
          {required: true, message: '请选择表决权开始日期', trigger: 'change'},
        ],
        profitRatioVoteEndDate: [
          {required: true, message: '请选择表决权结束日期', trigger: 'change'},
        ],

        // 实际控制类型
        actCtrlCpny: [
          {required: true, message: '请选择控制类型', trigger: 'change'},
        ],
        actCtrlType: [
          {required: true, message: '请选择控制内容', trigger: 'change'},
        ],
        actOtherForms: [
          {max: 500, message: '其他形式内容不超过500字符', trigger: 'blur'},
        ],
        obtainActDate: [
          {required: true, message: '请选择控制开始日期', trigger: 'change'},
        ],
        terminationActDate: [
          {required: true, message: '请选择控制结束日期', trigger: 'change'},
        ],

        // 上层实体信息
        actConUpperEntName: [
          {required: true, message: '请输入上层备案主体名称', trigger: 'blur'},
        ],
        actConUniScid: [
          {
            required: true,
            message: '请输入统一社会信用代码',
            trigger: 'blur',
          },
          {
            pattern: /^[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}$/,
            message: '请输入有效的18位统一社会信用代码',
            trigger: 'blur',
          }
        ],

        // 高管类型
        seniorMgrPos: [
          {required: true, message: '请选择职位', trigger: 'change'},
        ],
        actDailyMgmtPostOther: [
          {max: 300, message: '其他职位信息不能超过300字', trigger: 'blur'},
        ],

        // 在华高管类型
        seniorMgrPosCn: [
          {required: true, message: '请选择在华职位', trigger: 'change'},
        ],
        ownerRightMgmtPostOther: [
          {max: 300, message: '其他职位信息不能超过300字', trigger: 'blur'},
        ],
        benStartDate: [
          {required: true, message: '请选择开始日期', trigger: 'change'},
        ],
        benEndDate: [
          {required: true, message: '请选择结束日期', trigger: 'change'},
        ],
      },

      form: {
        departmentId: undefined,
        departmentCode: '',
        custnum: undefined,
        accountName: '',
        channelNo: undefined,
        appNo: '',
        account_no: '', // 编辑时使用
        mobile: '',
        verifyCode: '',
        primaryAccount: '',
        bankNo: undefined,
        bankName: undefined,
        idType: 'C',
        idNo: '',
        idStartDate: '',
        idEndDate: '',
        signName: '国家市场监督管理总局',
        idAddress: '',
        distcd: '',
        orgcodes: '',
        ratcodes: '',
        zsopscope: '',
        industry: 'F5219',
        companyIdType: 1,
        companyIdNo: '',
        companyIdName: '',
        companyOpto: '',
        controllerIdType: 1,
        controllerIdNo: '',
        controllerIdName: '',
        controllerOpto: '',
        leaderIdType: 1,
        leaderIdNo: '',
        leaderIdName: '',
        leaderMobile: '',
        leaderOpto: '',
        operatorIdType: 1,
        operatorIdNo: '',
        operatorIdName: '',
        operatorMobile: '',
        operatorOpto: '',

        // 多受益人数组（符合法规结构）
        beneficiaryList: [],

        // 编辑模式专用字段
        needToRemoveFile: [],
        companyCustNum: '',
        custEandpInfo: {},
      },

      IDcardfront: '',
      IDcardback: '',
      faceimage: '',
      companylist: [],
      citylist: BizDictCascade.DstcCd,

      rules: {
        departmentId: [
          {required: true, message: '请选择所属机构', trigger: 'change'},
        ],
        custnum: [{required: true, message: '请选择客户', trigger: 'change'}],
        accountName: [
          {required: true, message: '请输入客户名称', trigger: 'change'},
          {validator: validateBrackets, message: '客户名称为半角，建议在企业客户维护中修改为全角', trigger: 'change'}
        ],
        appNo: [
          {required: true, message: '请输入应用编号', trigger: 'blur'},
        ],
        idType: [
          {required: true, message: '请选择证件类型', trigger: 'blur'},
        ],
        channelNo: [
          {required: true, message: '请输入渠道编号', trigger: 'change'},
        ],
        mobile: [
          {required: true, message: '请输入手机号', trigger: 'blur'},
          {
            pattern: /^1[3-9]\d{9}$/,
            message: '请输入有效的手机号码',
            trigger: 'blur',
          },
        ],
        primaryAccount: [
          {
            required: true,
            message: '请输入任意银行的结算账号',
            trigger: 'blur',
          },
        ],
        bankNo: [
          {
            required: true,
            message: '请输入12位开户行大额行号',
            trigger: 'blur',
          },
        ],
        bankName: [
          {required: true, message: '请输入开户行名称', trigger: 'blur'},
        ],
        idStartDate: [
          {required: true, message: '请选择证件生效日期', trigger: 'change'},
        ],
        idNo: [
          {
            required: true,
            message: '请输入正确的18位营业执照编号',
            trigger: 'blur',
            pattern: /^(?:(?![IOZSV])[\dA-Z]){2}\d{6}(?:(?![IOZSV])[\dA-Z]){10}$/,
          },
        ],
        idEndDate: [
          {required: true, message: '请选择证件失效日期', trigger: 'change'},
        ],
        distcd: [
          {required: true, message: '请选择所属地区', trigger: 'change'},
        ],
        idAddress: [
          {required: true, message: '请输入经营地址', trigger: 'blur'},
        ],
        orgcodes: [
          {required: true, message: '请输入组织机构代码', trigger: 'blur'},
        ],
        ratcodes: [
          {required: true, message: '请输入税务登记号码', trigger: 'blur'},
        ],
        zsopscope: [
          {required: true, message: '请输入经营范围', trigger: 'blur'},
        ],
        industry: [
          {required: true, message: '请选择行业类别', trigger: 'change'},
        ],
        companyIdNo: [
          {
            required: true,
            trigger: 'blur',
            validator: validateIDCard,
          },
        ],
        companyIdName: [
          {required: true, message: '请输入法定代表人名称', trigger: 'blur'},
        ],
        companyOpto: [
          {
            required: true,
            message: '请输入法定代表人有效期止',
            trigger: 'change',
          },
        ],
        controllerIdNo: [
          {
            pattern: /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
            trigger: 'blur',
            message: '请输入有效身份证!',
          },
        ],
        leaderIdNo: [
          {
            pattern: /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
            trigger: 'blur',
            message: '请输入有效身份证!',
          },
        ],
        operatorIdNo: [
          {
            pattern: /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
            trigger: 'blur',
            message: '请输入有效身份证!',
          },
        ],
        operatorMobile: [
          {
            pattern: /^1[3-9]\d{9}$/,
            message: '请输入有效的手机号码',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  computed: {
    // 计算总持股比例（如果需要统计股权类型）
    totalShareRatio() {
      return this.form.beneficiaryList.reduce((total, beneficiary) => {
        if (beneficiary.identification_types.includes('equity') && typeof beneficiary.actHdRat === 'number') {
          return total + beneficiary.actHdRat
        }
        return total
      }, 0)
    },
    filteredRules() {
      const baseRules = {...this.rules};

      // 根据samePerson状态动态调整验证规则
      if (this.samePerson) {
        // 如果为同一人，不需要验证负责人、经办人、实际控制人的信息
        delete baseRules.controllerIdNo;
        delete baseRules.controllerIdName;
        delete baseRules.controllerOpto;
        delete baseRules.leaderIdNo;
        delete baseRules.leaderIdName;
        delete baseRules.leaderMobile;
        delete baseRules.leaderOpto;
        delete baseRules.operatorIdNo;
        delete baseRules.operatorIdName;
        delete baseRules.operatorMobile;
        delete baseRules.operatorOpto;
      }

      return baseRules;
    }
  },
  created() {
    // 初始化受益人列表，确保第一个受益人存在
    this.form.beneficiaryList = [defaultBeneficiary(true)]

    // 判断是否为编辑模式
    this.isEditMode = this.$route.query.mode === 'edit'
    console.log('this.$route.params.mode', this.$route.query.mode)
    if (!this.isEditMode) {
      this.getChannelList()
      if (this.$route.query.mode === 'add') {
        this.onCustChosen({custnum: this.$route.query.custnum})
      }
    } else {
      // 编辑模式，获取账户详情
      this.getAccountDetails()
    }
  },
  mounted() {
    if (this.$route.query.mode != 'add') {
      sessionStorage.setItem('msgInfo', true)
    }
  },
  watch: {
    "form.idEndDate": {
      handler: function (newVal) {
        if (newVal == "9999-12-31") {
          this.checkBoxValue = true;
        } else {
          this.checkBoxValue = false;
        }
      },
      immediate: true,
    },
    "form.companyOpto": {
      handler: function (newVal) {
        if (newVal == "9999-12-31") {
          this.id_checked = true;
        } else {
          this.id_checked = false;
        }
      },
      immediate: true,
    },
  },
  methods: {
    // 获取账户详情（编辑模式）
    async getAccountDetails() {
      let id = this.$route.query.id
      let res = await this.api.getAccountDetailsApi(id)
      if (res.code !== 200) {
        this.$message.error(res.info);
        return;
      }

      let custDetail = res.data
      console.log("getAccountDetails custDetail", custDetail)

      // 填充基本信息
      this.form.companyCustNum = custDetail.custnum
      this.form.channelNo = custDetail?.channelNo
      this.form.appNo = custDetail?.appNo
      this.form.account_no = custDetail?.accountNo
      this.form.accountName = custDetail.accountName
      this.form.custnum = custDetail.custnum
      this.form.idNo = custDetail.idInfo?.certnum
      this.form.idStartDate = custDetail.idInfo?.certeffectdt
      this.form.idEndDate = custDetail.idInfo?.certinvaliddt

      // 银行信息
      if (custDetail.bankCards && custDetail.bankCards.length > 0) {
        this.form.primaryAccount = custDetail.bankCards[0]?.bankCardNo
        this.form.bankName = custDetail.bankCards[0]?.bankName
        this.form.bankNo = custDetail.bankCards[0]?.bankNo
      }

      // 行业信息
      this.form.industry = custDetail.companyInfo?.belonginduscd || this.form.industry
      this.form.zsopscope = custDetail.companyInfo?.operbiz || ''

      // 地址信息
      if (custDetail.addressInfos && custDetail.addressInfos.length > 0) {
        this.form.distcd = custDetail.addressInfos[0]?.distcd
        this.form.idAddress = custDetail.addressInfos[0]?.addrinfo
      }

      // 受益人信息（转换为新的法规结构）
      this.form.beneficiaryList = []

      // 处理法定代表人和其他关系人
      if (custDetail.eandpInfos && custDetail.eandpInfos.length > 0) {
        custDetail.eandpInfos.forEach(item => {
          if (item.islegalperson === '1' && item.relatype === '0100') {
            // 法定代表人
            this.form.companyIdName = item.custname
            this.form.companyIdNo = item.certnnum
            this.form.companyOpto = item.certinvaliddt
          } else if (item.relatype === '0112') {
            // 其他受益人（按旧结构转换为新结构）
            this.form.beneficiaryList.push({
              // 基础信息
              beneName: item.custname,
              beneSex: item.gendercd === '1' ? '0' : '1',
              beneNationality: item.nationcd || '156',
              beneIdType: 'I', // 身份证
              beneIdNo: item.certnnum,
              beneOpto: item.certinvaliddt,
              beneAddress: item.addrinfo || '',
              beneMobile: item.continfo || '',
              beneBirthday: item.birthdt || null,

              // 认定类型（根据旧数据推测，这里需要业务方确认）
              identification_types: ['equity'], // 假设是股权类型

              // 股权类型字段
              actCtrl: 'Y',
              actHdRat: parseFloat(item.holdstockcnt) || 0,
              shareRatioStartDate: item.certeffectdt || null,
              shareRatioEndDate: item.certinvaliddt || null,

              // 其他类型字段（初始为空）
              priBenfit: '',
              actOwnerProfitRatio: null,
              actOwnerProfitRatioVote: null,
              profitRatioStartDate: null,
              profitRatioEndDate: null,
              profitRatioVoteStartDate: null,
              profitRatioVoteEndDate: null,

              actCtrlCpny: '',
              actCtrlType: '',
              actOtherForms: '',
              obtainActDate: null,
              terminationActDate: null,

              actConUpperMarket: false,
              actConUpperEntName: '',
              actConUniScid: '',

              seniorMgr: '',
              seniorMgrPos: '',
              actDailyMgmtPostOther: '',

              seniorMgrCn: '',
              seniorMgrPosCn: '',
              ownerRightMgmtPostOther: '',
              benStartDate: null,
              benEndDate: null,
            })

          } else if (item.relatype === '0109') {
            // 实际控制人
            this.form.controllerIdNo = item.certnnum
            this.form.controllerIdName = item.custname
            this.form.controllerOpto = item.certinvaliddt
          } else if (item.relatype === '0102') {
            // 负责人
            this.form.leaderIdNo = item.certnnum
            this.form.leaderIdName = item.custname
            this.form.leaderOpto = item.certinvaliddt
            this.form.leaderMobile = item.continfo
          } else if (item.relatype === '0104') {
            // 经办人
            this.form.operatorIdNo = item.certnnum
            this.form.operatorIdName = item.custname
            this.form.operatorOpto = item.certinvaliddt
            this.form.operatorMobile = item.continfo
          }
        })

        console.log("this.form.beneficiaryList", this.form.beneficiaryList)
      }

      // 如果只有一个受益人（法定代表人），调整持股比例为100%
      if (this.form.beneficiaryList.length === 1) {
        this.form.beneficiaryList[0].identification_types = ['equity']
        this.form.beneficiaryList[0].actHdRat = 100
      }

      // 影像信息
      this.fileList = custDetail.materials || this.fileList

      // 回显影像
      this.fileList.forEach(item => {
        if (item.fileType === '01') {
          // 人像面
          this.$refs.IdBack?.HumanfaceEcho(item.fileNo);
          this.verifyvadata.Frontofidentitycardurl = '已上传'
        } else if (item.fileType === '02') {
          // 回显国徽面
          this.$refs.IdUp?.HumanfaceEcho(item.fileNo);
          this.verifyvadata.ReverseofIDcardurl = '已上传'
        } else if (item.fileType === '12') {
          // 回显营业执照
          this.$refs.Businesslicense?.HumanfaceEcho(item.fileNo)
          this.verifyvadata.Businesslicenseurl = '已上传'
        } else if (item.fileType === '05') {
          // 回显受益人材料证明（图片或文件）
          const fileName = item.fileName || item.file_name || ''
          const ext = fileName.split('.').pop()?.toLowerCase() || ''
          const imageExts = ['png', 'jpg', 'jpeg', 'gif', 'bmp', 'tiff', 'webp']
          const isImage = imageExts.includes(ext)
          
          this.verifyvadata.BeneficiaryMaterialProofIsImage = isImage
          this.verifyvadata.BeneficiaryMaterialProofExt = ext
          this.verifyvadata.BeneficiaryMaterialProofName = fileName || '已上传'
          
          if (isImage) {
            this.$refs.BeneficiaryMaterialProofUpload?.HumanfaceEcho(item.fileNo)
            this.verifyvadata.BeneficiaryMaterialProofurl = '已上传'
          } else {
            this.verifyvadata.BeneficiaryMaterialProofFile = item.fileNo
            this.verifyvadata.BeneficiaryMaterialProofurl = 'file'
            this.verifyvadata.BeneficiaryMaterialProofName = fileName || '已上传'
          }
        } else if (item.fileType === '06') {
          // 兼容旧 fileType '06' 数据
          const fileName = item.fileName || item.file_name || ''
          const ext = fileName.split('.').pop()?.toLowerCase() || ''
          this.verifyvadata.BeneficiaryMaterialProofFile = item.fileNo
          this.verifyvadata.BeneficiaryMaterialProofurl = 'file'
          this.verifyvadata.BeneficiaryMaterialProofExt = ext
          this.verifyvadata.BeneficiaryMaterialProofName = fileName || '已上传'
          this.verifyvadata.BeneficiaryMaterialProofIsImage = false
        }
      })

      this.form.mobile = custDetail.mobile

      // 特殊渠道处理
      if (this.form.channelNo == '1028') {
        this.form.mobile = '15925968073'
        this.mobileDisabled = true
      }
    },

    changeBank(obj) {
      this.form.bankNo = obj.value
      this.form.bankName = obj['option'].componentOptions.children[0].text
      this.isShowBankChoose = false
      this.$nextTick(() => {
        this.$refs.ruleForm.validateField('bankName', 'bankNo');
      });
    },

    async onCustChosen(custChosen) {
      let res = await this.api.getEnterpriseCust(custChosen.custnum)
      if (res.code !== 200) {
        this.$message.error(res.info)
        return
      }

      let detail = res.data
      let custCompanyInfo = detail.custCompanyInfo
      this.form.departmentId = custCompanyInfo?.departmentId
      this.form.departmentCode = custCompanyInfo?.departmentCode
      this.form.accountName = custCompanyInfo?.custname
      this.form.custnum = custCompanyInfo?.custnum
      this.form.idNo = detail.custIdInfo?.certnum
      this.form.idStartDate = detail.custIdInfo?.certeffectdt
      this.form.idEndDate = detail.custIdInfo?.certinvaliddt


      if (detail.custAddressInfos && detail.custAddressInfos.length > 0) {
        let dict = dict_rawdata_cascade.region_raw.find(
            (i) => i.r === detail.custAddressInfos[0].distcd
        )
        this.form.distcd = detail.custAddressInfos[0].distcd
        this.form.idAddress = detail.custAddressInfos[0].addrinfo
        if (dict && detail.custAddressInfos[0].addrinfo?.substring(0, 5).indexOf('市') < 0) {
          this.form.idAddress = (dict.p.indexOf('省') >= 0 ? dict.p : '') + dict.c + dict.d + this.form.idAddress
        }
      }
      this.form.zsopscope = detail.custCompanyInfo?.operbiz
      this.form.industry = detail.custCompanyInfo?.belonginduscd || this.form.industry

      if (detail.custEandpInfos && detail.custEandpInfos.length > 0) {
        this.form.companyIdNo = detail.custEandpInfos[0].certnnum
        this.form.companyIdName = detail.custEandpInfos[0].custname
        this.form.companyOpto = detail.custEandpInfos[0].certinvaliddt
      }
      console.log("this.form.",this.form)
    },

    async onLrChosen(cust) {
      let res = await this.api.getCustData(cust.custnum)
      if (res.code !== 200) {
        this.$message.error(res.info)
        return
      }
      let custDetail = res.data

      this.form.companyIdName = cust.custname

      // 查找受益人列表中是否已存在该法定代表人
      const existingIndex = this.form.beneficiaryList.findIndex(b => b.beneName === cust.custname)

      if (existingIndex >= 0) {
        // 如果已存在，更新该受益人的信息
        let beneficiary = this.form.beneficiaryList[existingIndex]
        beneficiary.beneName = cust.custname
        beneficiary.beneSex = cust.gendercd === '1' ? '0' : '1'

        if (custDetail.custIdInfo) {
          this.form.companyIdNo = custDetail.custIdInfo?.certnum
          this.form.companyOpto = custDetail.custIdInfo?.certinvaliddt
          beneficiary.beneIdNo = custDetail.custIdInfo?.certnum
          beneficiary.beneOpto = custDetail.custIdInfo?.certinvaliddt
        }

        if (custDetail.custAddressInfos?.length > 0) {
          let custDistcd = custDetail.custAddressInfos[0].distcd
          let dict = dict_rawdata_cascade.region_raw.find((i) => i.r === custDistcd)
          if (dict) {
            beneficiary.beneAddress = dict.c + dict.d + custDetail.custAddressInfos[0].addrinfo
          } else {
            beneficiary.beneAddress = custDetail.custAddressInfos[0].addrinfo
          }
        }

        this.$message.success(`已更新受益人: ${cust.custname}`)
      } else {
        // 如果不存在，检查是否需要添加或更新第一个受益人

        // 如果受益人数组为空，则自动添加第一个受益人（法定代表人）
        if (this.form.beneficiaryList.length === 0) {
          this.addFirstBeneficiary()
        }

        // 填充第一个受益人信息（法定代表人信息）
        if (this.form.beneficiaryList.length > 0) {
          let firstBeneficiary = this.form.beneficiaryList[0]
          firstBeneficiary.beneName = cust.custname
          firstBeneficiary.beneSex = cust.gendercd === '1' ? '0' : '1'

          if (custDetail.custIdInfo) {
            this.form.companyIdNo = custDetail.custIdInfo?.certnum
            this.form.companyOpto = custDetail.custIdInfo?.certinvaliddt
            firstBeneficiary.beneIdNo = custDetail.custIdInfo?.certnum
            firstBeneficiary.beneOpto = custDetail.custIdInfo?.certinvaliddt
          }

          if (custDetail.custAddressInfos?.length > 0) {
            let custDistcd = custDetail.custAddressInfos[0].distcd
            let dict = dict_rawdata_cascade.region_raw.find((i) => i.r === custDistcd)
            if (dict) {
              firstBeneficiary.beneAddress = dict.c + dict.d + custDetail.custAddressInfos[0].addrinfo
            } else {
              firstBeneficiary.beneAddress = custDetail.custAddressInfos[0].addrinfo
            }
          }
        }
      }

      // 编辑模式下标记需要更新图片
      if (this.isEditMode) {
        this.allowImageEdit = true
        const fileTypes = ['01', '02', '12'];
        this.form.needToRemoveFile = this.fileList.filter(item => {
          return fileTypes.includes(item.fileType);
        });

        // 清空图片数据
        this.verifyvadata.Frontofidentitycardurl = '';
        this.verifyvadata.FrontofidentitycardFile = '';
        this.verifyvadata.Frontofidentitycardloading = false;

        this.verifyvadata.ReverseofIDcard = '';
        this.verifyvadata.ReverseofIDcardurl = '';
        this.verifyvadata.ReverseofIDcardloading = false;

        this.verifyvadata.Businesslicenseurl = '';
        this.verifyvadata.BusinesslicenseFile = '';
        this.verifyvadata.Businesslicenseloading = false;

        this.verifyvadata.BeneficiaryMaterialProofurl = '';
        this.verifyvadata.BeneficiaryMaterialProofFile = '';
        this.verifyvadata.BeneficiaryMaterialProofloading = false;
        this.verifyvadata.BeneficiaryMaterialProofIsImage = true;
        this.verifyvadata.BeneficiaryMaterialProofExt = '';
        this.verifyvadata.BeneficiaryMaterialProofName = '';
      }

      //处理法定代表人、负责人、经办人均为同一人
      this.handleSamePersonChange(true)
    },

    // 添加第一个受益人（法定代表人）
    addFirstBeneficiary() {
      this.form.beneficiaryList.push(defaultBeneficiary(true))
    },

    // 添加其他受益人
    addBeneficiary() {
      this.form.beneficiaryList.push(defaultBeneficiary(false))
    },

    // 删除受益人
    removeBeneficiary(index) {
      if (index === 0) {
        this.$message.warning('第一个受益人（法定代表人）不可删除')
        return
      }
      this.form.beneficiaryList.splice(index, 1)
    },

    // 受益人类型变化时的处理（实现互斥逻辑）
    onBeneficiaryTypeChange(index) {
      const beneficiary = this.form.beneficiaryList[index]
      const selectedTypes = beneficiary.identification_types

      // 检查互斥规则
      const hasEquity = selectedTypes.includes('equity')
      const hasSeniorMgr = selectedTypes.includes('seniorMgr')
      const hasForeignBranch = selectedTypes.includes('foreignBranch')
      const hasProfitVote = selectedTypes.includes('profitVote')
      const hasControl = selectedTypes.includes('control')

      // 规则2-4：股权、日常经营管理、在华最高层级高管必须单选
      if (hasEquity && selectedTypes.length > 1) {
        this.$message.warning('选择股权/合伙权益类型时，不能选择其他类型')
        beneficiary.identification_types = ['equity']
      } else if (hasSeniorMgr && selectedTypes.length > 1) {
        this.$message.warning('选择日常经营管理类型时，不能选择其他类型')
        beneficiary.identification_types = ['seniorMgr']
      } else if (hasForeignBranch && selectedTypes.length > 1) {
        this.$message.warning('选择在华最高层级高管类型时，不能选择其他类型')
        beneficiary.identification_types = ['foreignBranch']
      }

      // 更新标志位
      this.updateBeneficiaryFlags(beneficiary)

      // 触发验证
      this.$nextTick(() => {
        this.$refs.ruleForm.validateField(`beneficiaryList[${index}].identification_types`)
      })
    },

    // 更新受益人标志位
    updateBeneficiaryFlags(beneficiary) {
      const types = beneficiary.identification_types || []

      // 股权类型
      beneficiary.actCtrl = types.includes('equity') ? 'Y' : 'N'
      if (!types.includes('equity')) {
        beneficiary.actHdRat = null
        beneficiary.shareRatioStartDate = null
        beneficiary.shareRatioEndDate = null
      }

      // 收益权/表决权类型
      beneficiary.priBenfit = types.includes('profitVote') ? 'Y' : 'N'
      if (!types.includes('profitVote')) {
        beneficiary.actOwnerProfitRatio = null
        beneficiary.actOwnerProfitRatioVote = null
        beneficiary.profitRatioStartDate = null
        beneficiary.profitRatioEndDate = null
        beneficiary.profitRatioVoteStartDate = null
        beneficiary.profitRatioVoteEndDate = null
      }

      // 实际控制类型
      beneficiary.actCtrlCpny = types.includes('control') ? '1' : ''
      if (!types.includes('control')) {
        beneficiary.actCtrlCpny = ''
        beneficiary.actCtrlType = ''
        beneficiary.actOtherForms = ''
        beneficiary.obtainActDate = null
        beneficiary.terminationActDate = null
        beneficiary.actConUpperMarket = false
        beneficiary.actConUpperEntName = ''
        beneficiary.actConUniScid = ''
      }

      // 日常经营管理高管类型
      beneficiary.seniorMgr = types.includes('seniorMgr') ? 'Y' : 'N'
      if (!types.includes('seniorMgr')) {
        beneficiary.seniorMgrPos = ''
        beneficiary.actDailyMgmtPostOther = ''
      }

      // 在华最高层级高管类型
      beneficiary.seniorMgrCn = types.includes('foreignBranch') ? 'Y' : 'N'
      if (!types.includes('foreignBranch')) {
        beneficiary.seniorMgrPosCn = ''
        beneficiary.ownerRightMgmtPostOther = ''
        beneficiary.benStartDate = null
        beneficiary.benEndDate = null
      }
    },

    // 受益人长期复选框处理
    handleBeneficiaryLongTerm(index, event) {
      if (event.target.checked) {
        this.form.beneficiaryList[index].beneOpto = '9999-12-31'
      } else {
        this.form.beneficiaryList[index].beneOpto = ''
      }
    },

    onChangeActConUpperMarket(checked) {
      console.log(`a-switch to ${checked}`);
    },

    mapMapList: function (code) {
      let obj = ''
      let mapList = this.$store.state.getMapList;
      if (!mapList) {
        return obj
      }
      mapList.forEach((item) => {
        if (item.code === code) {
          obj = item
        }
      })
      return obj
    },

    async downLoadTemplate(type) {
      contractDocTemp.call(this, type, this.api, this.$message)
    },

    async getChannelList() {
      const res = await this.api.coreCompanyInfoApi()
      if (res.code !== 200) {
        this.$message.error(res.info)
        return
      }

      this.companylist = []
      res.data.forEach((item) => {
        this.companylist.push({
          label: item.channelName + '（' + item.channelNo + '）',
          value: item.channelNo,
          info: item,
        })
      })
      if (this.companylist.length === 1) {
        this.form.channelNo = this.companylist[0]?.value
        this.channel_nochange(this.form.channelNo)
      }
    },

    channel_nochange(val) {
      this.companylist.forEach((item) => {
        if (Number(val) == Number(item.value)) {
          this.form.appNo = item.info.appNo
        }
        if (this.form.channelNo == '1028') {
          this.form.mobile = '15925968073'
          this.mobileDisabled = true
        } else {
          this.form.mobile = ''
          this.mobileDisabled = false
        }
      })
    },

    async sendcode() {
      var validateResult = []
      await this.$refs.ruleForm.validateField(
          [
            'appNo',
            'mobile',
            'channelNo',
            'primaryAccount',
            'primaryAccount',
            'idNo',
          ],
          (errorMsg) => validateResult.push(errorMsg)
      )
      if (validateResult.every((item) => item === '')) {
        const tradeType = this.isEditMode ? 4 : 0
        const sendData = {
          appNo: this.form.appNo,
          channelNo: this.form.channelNo,
          mobile: Number(this.form.mobile),
          cardNo: this.form.primaryAccount,
          accountName: this.form.accountName,
          idNo: this.form.idNo,
          tradeType: tradeType,
        }

        if (this.isEditMode) {
          sendData.accountNo = this.form.account_no
        }

        const res = await this.api.vefifycodesend(sendData)
        if (res.code === 200) {
          this.$message.success(res.info)
          return true
        } else {
          this.$message.error(res.msg)
          return false
        }
      } else {
        return false
      }
    },

    fillinfo(type) {
      if (type == 1) {
        // 实际控制人
        this.form.controllerIdNo = this.form.companyIdNo;
        this.form.controllerIdName = this.form.companyIdName;
        this.form.controllerOpto = this.form.companyOpto;
      }
      if (type == 2) {
        // 负责人
        this.form.leaderIdNo = this.form.companyIdNo;
        this.form.leaderIdName = this.form.companyIdName;
        this.form.leaderOpto = this.form.companyOpto;
        // 如果需要的话，也可以填充手机号
        // this.form.leaderMobile = this.form.mobile;
      }
      if (type == 3) {
        // 经办人
        this.form.operatorIdNo = this.form.companyIdNo;
        this.form.operatorIdName = this.form.companyIdName;
        this.form.operatorOpto = this.form.companyOpto;
        // 如果需要的话，也可以填充手机号
        // this.form.operatorMobile = this.form.mobile;
      }
    },
    // 在samePerson切换时自动填充信息
    handleSamePersonChange(newValue) {
      if (newValue) {
        // 当设为同一人时，自动用法定代表人信息填充其他字段
        this.form.controllerIdNo = this.form.companyIdNo;
        this.form.controllerIdName = this.form.companyIdName;
        this.form.controllerOpto = this.form.companyOpto;

        this.form.leaderIdNo = this.form.companyIdNo;
        this.form.leaderIdName = this.form.companyIdName;
        this.form.leaderOpto = this.form.companyOpto;

        this.form.operatorIdNo = this.form.companyIdNo;
        this.form.operatorIdName = this.form.companyIdName;
        this.form.operatorOpto = this.form.companyOpto;
      }
    },

    async confirm() {
      if (!this.isEditMode && !this.Userauthorization) {
        this.$message.warning(`请先同意${this.mapMapList('TMPL_CZCB_SRVC').state}和${this.mapMapList('TMPL_CZCB_PRVC').state}`)
        return
      }

      // 检查是否有受益人数据
      if (this.form.beneficiaryList.length === 0) {
        this.$message.warning('请至少添加一个受益人信息')
        return
      }

      // 检查受益人数据合规性
      for (let i = 0; i < this.form.beneficiaryList.length; i++) {
        const beneficiary = this.form.beneficiaryList[i]

        // 检查至少选择一种类型
        if (!beneficiary.identification_types || beneficiary.identification_types.length === 0) {
          this.$message.warning(`第${i + 1}位受益人必须至少选择一种认定类型`)
          return
        }

        // 检查收益权/表决权类型
        if (beneficiary.identification_types.includes('profitVote')) {
          const hasProfitRatio = beneficiary.actOwnerProfitRatio !== null && beneficiary.actOwnerProfitRatio !== '';
          const hasVoteRatio = beneficiary.actOwnerProfitRatioVote !== null && beneficiary.actOwnerProfitRatioVote !== '';

          // 规则5：收益权和表决权至少填写一个
          if (!hasProfitRatio && !hasVoteRatio) {
            this.$message.warning(`第${i + 1}位受益人（收益权/表决权类型）收益权或表决权比例至少填写一项`)
            return
          }

          // 检查比例是否≥25%
          if (hasProfitRatio && beneficiary.actOwnerProfitRatio < 25) {
            this.$message.warning(`第${i + 1}位受益人（收益权/表决权类型）收益权比例应≥25%`)
            return
          }

          if (hasVoteRatio && beneficiary.actOwnerProfitRatioVote < 25) {
            this.$message.warning(`第${i + 1}位受益人（收益权/表决权类型）表决权比例应≥25%`)
            return
          }
        }

        // 检查实际控制类型必填字段
        if (beneficiary.identification_types.includes('control')) {
          if (!beneficiary.actCtrlCpny) {
            this.$message.warning(`第${i + 1}位受益人（实际控制类型）控制类型不能为空`)
            return
          }
          if (!beneficiary.actCtrlType) {
            this.$message.warning(`第${i + 1}位受益人（实际控制类型）控制内容不能为空`)
            return
          }
        }

        // 检查日常经营管理高管类型
        if (beneficiary.identification_types.includes('seniorMgr') && !beneficiary.seniorMgrPos) {
          this.$message.warning(`第${i + 1}位受益人（高管类型）职位不能为空`)
          return
        }

        // 检查在华最高层级高管类型
        if (beneficiary.identification_types.includes('foreignBranch') && !beneficiary.seniorMgrPosCn) {
          this.$message.warning(`第${i + 1}位受益人（在华高管类型）在华职位不能为空`)
          return
        }
      }

      var that = this
      let expiryDates = []

      // 收集所有需要检查的日期
      expiryDates.push(this.form.idEndDate, this.form.companyOpto)

      // 收集受益人证件有效期
      this.form.beneficiaryList.forEach(beneficiary => {
        expiryDates.push(beneficiary.beneOpto)
      })

      if (!this.samePerson) {
        expiryDates.push(
            this.form.controller_opto,
            this.form.operator_opto,
            this.form.leader_opto
        )
      }

      let arr = expiryDates.reduce((acc, item) => {
        if (item == '') {
          acc.push(this.endverify(dayjs().format('YYYY-MM-DD')))
        } else {
          acc.push(this.endverify(item))
        }
        return acc
      }, [])

      var flag = arr.every((item) => item == 2)
      var flagbefore = arr.some((item) => item == 0)
      var flagafter = this.checkArrayConditions(arr)

      this.$refs.ruleForm.validate((valid, a) => {
        console.info(a)
        if (valid) {
          if (
              this.verifyvadata.FrontofidentitycardFile == '' ||
              this.verifyvadata.ReverseofIDcardFile == '' ||
              this.verifyvadata.BusinesslicenseFile == ''
          ) {
            this.$message.warning('请先填写影像信息')
          } else {
            if (flag) {
              that.confirmshow = true
              return
            }
            if (flagbefore) {
              this.$message.warning('您的证件已经到期，建议使用最新的证件进行注册')
              return
            }
            if (flagafter) {
              this.$confirm({
                title: '提示',
                content: '您的证件将在半年内到期，届时银行将对您的账号进行管制。解除管制需要本人持有效证件前往稠州银行网点更新，建议使用最新的证件进行注册， 确定继续吗？',
                onOk() {
                  that.confirmshow = true
                },
                onCancel() {
                  // that.$refs.datePicker.focus();
                },
              })
              return
            }
          }
        } else {
          this.$message.warning('请先填写开户信息')
        }
      })
    },

    id_nochange() {
      this.form.orgcodes = this.form.idNo
      this.form.ratcodes = this.form.idNo
    },

    // 查询受益人信息
    async queryBeneficiary() {
      if (!this.form.channelNo) {
        this.$message.warning('请先选择渠道归属')
        return
      }
      if (!this.form.idNo) {
        this.$message.warning('请先输入统一社会信用代码')
        return
      }

      this.beneficiaryLoading = true
      this.beneficiaryDrawerVisible = true
      this.beneficiaryData = null

      try {
        const res = await this.api.beneficiaryQueryApi({
          channelNo: this.form.channelNo,
          creditCode: this.form.idNo,
          isGetCompanyInfo: '1'
        })

        if (res.code === 200 && res.success && res.data) {
          if (res.data.recode === '000000') {
            this.beneficiaryData = res.data
          } else {
            this.$message.error(res.data.recodeInfo || '查询失败')
          }
        } else {
          this.$message.error(res.info || '查询失败')
        }
      } catch (error) {
        console.error('查询受益人信息失败:', error)
        this.$message.error('查询受益人信息失败')
      } finally {
        this.beneficiaryLoading = false
      }
    },

    // 一键填充受益人信息
    fillBeneficiaryInfo() {
      if (!this.beneficiaryData) {
        this.$message.warning('暂无受益人信息')
        return
      }

      const { isPartialFill, existingLegalPerson } = this.prepareExistingData()
      const companyExpireDate = this.form?.idEndDate || ''
      const companyInfo = this.beneficiaryData.qccCompanyInfo || {}
      
      // 更新法定代表人信息
      this.updateLegalPersonInfo(existingLegalPerson, companyInfo)

      // 收集并处理所有受益人数据
      const { beneficiaryMap, equityDataMap, voteDataMap } = this.collectBeneficiaryData()
      
      // 构建受益人列表
      const { sortedBeneficiaries, adjustedTypesCount } = this.buildBeneficiaryList(
        beneficiaryMap, 
        equityDataMap, 
        voteDataMap, 
        companyExpireDate,
        existingLegalPerson.name
      )

      // 合并到表单
      this.mergeBeneficiaries(sortedBeneficiaries, isPartialFill, existingLegalPerson)

      // 根据业务规则调整类型时给出提示
      if (adjustedTypesCount > 0) {
        this.$message.info(`已根据受益所有权规则调整部分受益人类型（股权/高管类型不可与其他类型共存）`)
      }

      this.$message.success(`已填充${this.form.beneficiaryList.length}位受益人信息，第一位为法定代表人`)
      this.beneficiaryDrawerVisible = false
    },

    // 准备已有数据
    prepareExistingData() {
      const hasExistingData = this.form.beneficiaryList.some(b => b.beneName && b.beneIdNo)
      const firstBeneficiary = this.form.beneficiaryList[0] || {}
      
      return {
        isPartialFill: hasExistingData,
        existingLegalPerson: {
          name: this.form.companyIdName,
          idNo: this.form.companyIdNo,
          address: firstBeneficiary.beneAddress || '',
          mobile: firstBeneficiary.beneMobile || ''
        }
      }
    },

    // 更新法定代表人信息
    updateLegalPersonInfo(existingLegalPerson, companyInfo) {
      const queryLegalPersonName = companyInfo?.oper || ''
      const finalLegalPersonName = existingLegalPerson.name || queryLegalPersonName
      
      if (finalLegalPersonName) {
        this.form.companyIdName = finalLegalPersonName
        if (!this.form.companyIdNo) {
          this.form.companyIdNo = existingLegalPerson.idNo || ''
        }
      }
    },

    // 收集并处理所有受益人数据
    collectBeneficiaryData() {
      const beneficiaryMap = new Map()
      const equityDataMap = new Map()
      const voteDataMap = new Map()
      const equityNames = new Set()

      // 处理股权信息
      const breakThroughList = this.beneficiaryData.qccBreakThroughList || []
      breakThroughList.forEach(item => {
        const name = item.name
        const position = item.position || ''
        const totalStockPercent = this.parsePercent(item.totalStockPercent) || 0
        const isLegalRepresentative = position.includes('法定代表人') || position.includes('董事长')
        
        equityNames.add(name)
        equityDataMap.set(name, { position, totalStockPercent, hasEquity: true, isLegalRepresentative })
        
        if (!beneficiaryMap.has(name)) {
          beneficiaryMap.set(name, { data: item, types: new Set(['equity']) })
        } else {
          beneficiaryMap.get(name).types.add('equity')
        }
      })

      // 处理表决权/收益权信息
      const criterion2ndList = this.beneficiaryData.qccCriterion2ndInfoList || []
      criterion2ndList.forEach(item => {
        const name = item.name
        const votingPercent = this.parsePercent(item.votingPercent) || 0
        const totalStockPercent = this.parsePercent(item.totalStockPercent) || 0
        
        voteDataMap.set(name, { votingPercent, totalStockPercent })
        
        if (!beneficiaryMap.has(name)) {
          beneficiaryMap.set(name, { data: item, types: new Set(['profitVote']) })
        } else {
          beneficiaryMap.get(name).types.add('profitVote')
        }
      })

      // 处理控制/影响自然人信息
      const criterion3rdList = this.beneficiaryData.qccCriterion3rdInfoList || []
      criterion3rdList.forEach(item => {
        const name = item.name
        if (!beneficiaryMap.has(name)) {
          beneficiaryMap.set(name, { data: item, types: new Set(['control']) })
        } else {
          beneficiaryMap.get(name).types.add('control')
        }
      })

      // 处理日常经营管理人员信息
      const managerList = this.beneficiaryData.qccManagerList || []
      managerList.forEach(item => {
        const name = item.name
        const position = item.position || ''
        const isLegalRepresentative = position.includes('法定代表人') || position.includes('董事长')
        const hasEquity = equityNames.has(name)
        
        if (!beneficiaryMap.has(name)) {
          beneficiaryMap.set(name, { data: item, types: new Set(['seniorMgr']) })
        } else if (isLegalRepresentative && !hasEquity) {
          beneficiaryMap.get(name).types.add('seniorMgr')
        }
      })

      return { beneficiaryMap, equityDataMap, voteDataMap }
    },

    // 构建受益人列表
    buildBeneficiaryList(beneficiaryMap, equityDataMap, voteDataMap, companyExpireDate, legalPersonName) {
      let adjustedTypesCount = 0
      const sortedBeneficiaries = []

      beneficiaryMap.forEach((value, name) => {
        const typesArray = Array.from(value.types)
        const finalTypes = this.applyMutualExclusionRule(typesArray)

        if (finalTypes.length !== typesArray.length) {
          adjustedTypesCount++
        }

        const firstType = finalTypes[0]
        const beneficiary = this.createBeneficiaryFromData(value.data, firstType)

        // 处理附加类型
        for (let i = 1; i < finalTypes.length; i++) {
          const type = finalTypes[i]
          beneficiary.identification_types.push(type)
          
          if (type === 'profitVote') {
            beneficiary.actOwnerProfitRatio = this.parsePercent(value.data.percent)
            beneficiary.actOwnerProfitRatioVote = this.parsePercent(value.data.votingPercent)
            beneficiary.priBenfit = 'Y'
          } else if (type === 'control') {
            beneficiary.actCtrlCpny = '2'
            beneficiary.actCtrlType = '0'
          }
        }

        // 填充日期字段
        this.fillDateFields(beneficiary, value.data, firstType, companyExpireDate)

        const isLegalPerson = name === legalPersonName
        sortedBeneficiaries.push({ beneficiary, isLegalPerson, name })
      })

      // 排序：法定代表人放第一位
      sortedBeneficiaries.sort((a, b) => {
        if (a.isLegalPerson && !b.isLegalPerson) return -1
        if (!a.isLegalPerson && b.isLegalPerson) return 1
        return 0
      })

      return { sortedBeneficiaries, adjustedTypesCount }
    },

    // 填充日期字段
    fillDateFields(beneficiary, data, type, companyExpireDate) {
      // 填充形成日期
      if (data.uboDate) {
        const dateMap = {
          equity: 'shareRatioStartDate',
          profitVote: 'profitRatioStartDate',
          control: 'obtainActDate',
          foreignBranch: 'benStartDate'
        }
        if (type === 'profitVote') {
          beneficiary.profitRatioVoteStartDate = data.uboDate
        }
        if (dateMap[type]) {
          beneficiary[dateMap[type]] = data.uboDate
        }
      }

      // 填充终止日期
      const endDateMap = {
        equity: 'shareRatioEndDate',
        profitVote: 'profitRatioEndDate',
        control: 'terminationActDate',
        foreignBranch: 'benEndDate'
      }
      if (type === 'profitVote') {
        beneficiary.profitRatioVoteEndDate = companyExpireDate
      }
      if (endDateMap[type]) {
        beneficiary[endDateMap[type]] = companyExpireDate
      }
      // 注意：beneOpto 不再自动填充，由用户手动填写
    },

    // 合并受益人数据
    mergeBeneficiaries(sortedBeneficiaries, isPartialFill, existingLegalPerson) {
      if (!isPartialFill) {
        this.form.beneficiaryList = []
      }

      sortedBeneficiaries.forEach((item, index) => {
        const existingBeneficiary = isPartialFill
          ? this.form.beneficiaryList.find(b => b.beneName === item.name)
          : null

        if (existingBeneficiary) {
          this.fillEmptyFields(existingBeneficiary, item.beneficiary)
        } else {
          // 第一个受益人（法定代表人）保留用户已填写的信息
          if (index === 0 && item.isLegalPerson) {
            if (existingLegalPerson.idNo) item.beneficiary.beneIdNo = existingLegalPerson.idNo
            if (existingLegalPerson.address) item.beneficiary.beneAddress = existingLegalPerson.address
            if (existingLegalPerson.mobile) item.beneficiary.beneMobile = existingLegalPerson.mobile
          }
          
          this.form.beneficiaryList.push(item.beneficiary)
          this.updateBeneficiaryFlags(item.beneficiary)
        }
      })
    },

    // 填充空字段
    fillEmptyFields(existing, newData) {
      const fields = [
        'beneIdNo', 'beneAddress', 'beneMobile', 'beneSex', 'beneNationality',
        'actHdRat', 'actOwnerProfitRatio', 'actOwnerProfitRatioVote', 'actCtrl', 'priBenfit',
        'actCtrlCpny', 'actCtrlType', 'shareRatioStartDate', 'shareRatioEndDate',
        'profitRatioStartDate', 'profitRatioEndDate', 'profitRatioVoteStartDate', 'profitRatioVoteEndDate',
        'obtainActDate', 'terminationActDate', 'benStartDate', 'benEndDate'
      ]

      fields.forEach(field => {
        const existingValue = existing[field]
        const newValue = newData[field]
        if (!existingValue && newValue) {
          existing[field] = newValue
        }
      })

      // 处理类型字段
      if ((!existing.identification_types || existing.identification_types.length === 0)
          && newData.identification_types.length > 0) {
        existing.identification_types = this.applyMutualExclusionRule(newData.identification_types)
        this.updateBeneficiaryFlags(existing)
      }
    },

    // 根据数据类型创建受益人对象
    createBeneficiaryFromData(data, type) {
      const beneficiary = defaultBeneficiary(false)
      beneficiary.beneName = data.name || ''

      // 从公司信息中获取法人代表作为第一个受益人
      if (type === 'equity' && this.beneficiaryData.qccCompanyInfo) {
        beneficiary.beneName = data.name || this.beneficiaryData.qccCompanyInfo.oper || ''
      }

      // 根据互斥逻辑设置类型 - 参考 onBeneficiaryTypeChange 逻辑
      if (type === 'equity') {
        // 股权类型单独选择
        beneficiary.identification_types = ['equity']
      } else if (type === 'seniorMgr') {
        // 日常经营管理高管类型单独选择
        beneficiary.identification_types = ['seniorMgr']
      } else if (type === 'foreignBranch') {
        // 在华最高层级高管类型单独选择
        beneficiary.identification_types = ['foreignBranch']
      } else {
        // 其他类型可以组合（如收益权/表决权和实际控制）
        beneficiary.identification_types = [type]
      }

      // 设置股权类型字段
      if (type === 'equity') {
        beneficiary.actHdRat = this.parsePercent(data.totalStockPercent)
        beneficiary.actCtrl = 'Y'
      }

      // 设置收益权/表决权类型字段
      if (type === 'profitVote') {
        beneficiary.actOwnerProfitRatio = this.parsePercent(data.percent)
        beneficiary.actOwnerProfitRatioVote = this.parsePercent(data.votingPercent)
        beneficiary.priBenfit = 'Y'
      }

      // 设置实际控制类型字段
      if (type === 'control') {
        beneficiary.actCtrlCpny = '2'  // 协议约定形式
        beneficiary.actCtrlType = '0'   // 决定法定代表人、董事、监事、高级管理人员的任免
      }

      // 设置日常经营管理高管类型字段
      if (type === 'seniorMgr') {
        beneficiary.seniorMgr = 'Y'
        // 从职位中提取
        if (data.position) {
          if (data.position.includes('法定') || data.position.includes('董事长')) {
            beneficiary.seniorMgrPos = '10'
          } else if (data.position.includes('经理')) {
            beneficiary.seniorMgrPos = '12'
          } else if (data.position.includes('董事')) {
            beneficiary.seniorMgrPos = '13'
          } else {
            beneficiary.seniorMgrPos = '15'
            beneficiary.actDailyMgmtPostOther = data.position

          }
        }
      }

      // 设置在华最高层级高管类型字段
      if (type === 'foreignBranch') {
        beneficiary.seniorMgrCn = 'Y'
        // 默认设置为分支机构负责人
        beneficiary.seniorMgrPosCn = '0'
      }

      // 调用 updateBeneficiaryFlags 确保正确设置标志位和清空未使用的字段
      this.updateBeneficiaryFlags(beneficiary)

      return beneficiary
    },

    // 解析百分比字符串
    parsePercent(value) {
      if (!value) return null
      const num = parseFloat(value.replace('%', ''))
      return isNaN(num) ? null : num
    },

    // 从身份证号解析出生日期
    parseBirthdayFromIdNo(idNo) {
      if (!idNo || (idNo.length !== 18 && idNo.length !== 15)) {
        return null
      }

      let birthStr = ''
      if (idNo.length === 18) {
        // 18位身份证：第7-14位为出生年月日（YYYYMMDD）
        birthStr = idNo.substring(6, 14)
      } else if (idNo.length === 15) {
        // 15位身份证：第7-12位为出生年月日（YYMMDD），需要补上19开头的年份
        birthStr = '19' + idNo.substring(6, 12)
      }

      // 验证是否为合法日期格式
      const year = parseInt(birthStr.substring(0, 4))
      const month = parseInt(birthStr.substring(4, 6))
      const day = parseInt(birthStr.substring(6, 8))

      // 基本验证
      if (isNaN(year) || isNaN(month) || isNaN(day) ||
          month < 1 || month > 12 || day < 1 || day > 31) {
        return null
      }

      // 格式化为 YYYY-MM-DD
      const formattedDate = `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`

      // 验证日期是否真实存在（例如防止2月30日这样的错误）
      const dateObj = new Date(formattedDate)
      if (dateObj.getFullYear() !== year ||
          dateObj.getMonth() + 1 !== month ||
          dateObj.getDate() !== day) {
        return null
      }

      return formattedDate
    },

    // 当受益人身份证号改变时自动填充生日
    onBeneficiaryIdNoChange(index) {
      const beneficiary = this.form.beneficiaryList[index]
      const idNo = beneficiary.beneIdNo

      if (idNo) {
        const birthday = this.parseBirthdayFromIdNo(idNo)
        if (birthday) {
          // 设置出生日期
          beneficiary.beneBirthday = birthday
          // 可以在这里添加提示信息
          // this.$message.success(`已从身份证号自动填充出生日期: ${birthday}`)
        } else {
          // 如果身份证号格式不正确，清空生日
          beneficiary.beneBirthday = null
        }
        
        // 根据身份证号自动填充性别
        if (idNo.length === 18) {
          // 第17位数字（索引16）表示性别，奇数为男性('1')，偶数为女性('0')
          const genderDigit = parseInt(idNo.charAt(16))
          if (!isNaN(genderDigit)) {
            beneficiary.beneSex = genderDigit % 2 === 0 ? '1' : '0' // 0表示男性，1表示女性
          }
        } else if (idNo.length === 15) {
          // 15位身份证号的第15位（索引14）表示性别
          const genderDigit = parseInt(idNo.charAt(14))
          if (!isNaN(genderDigit)) {
            beneficiary.beneSex = genderDigit % 2 === 0 ? '1' : '0' // 0表示男性，1表示女性
          }
        }
      }
    },

    // 应用互斥规则来设置受益人类型
    applyMutualExclusionRule(selectedTypes) {
      const hasEquity = selectedTypes.includes('equity')
      const hasSeniorMgr = selectedTypes.includes('seniorMgr')
      const hasForeignBranch = selectedTypes.includes('foreignBranch')

      // 规则2: 若选择了"股权/合伙权益 ≥25%"，则不能选择其他类型
      if (hasEquity) {
        if (selectedTypes.length > 1) {
          this.$message.warning('选择股权/合伙权益类型时，不能选择其他类型')
          return ['equity']
        }
      }
      // 规则3: 若选择了"日常经营管理高管"，则不能选择其他类型
      else if (hasSeniorMgr) {
        if (selectedTypes.length > 1) {
          this.$message.warning('选择日常经营管理类型时，不能选择其他类型')
          return ['seniorMgr']
        }
      }
      // 规则4: 若选择了"在华最高层级高管"，则不能选择其他类型
      else if (hasForeignBranch) {
        if (selectedTypes.length > 1) {
          this.$message.warning('选择在华最高层级高管类型时，不能选择其他类型')
          return ['foreignBranch']
        }
      }

      // 规则6: "收益权/表决权 ≥25%"和"实际控制"类型，可组合选择、也可单选
      // 这两个类型可以和其他类型组合，但不与股权、高管类互斥

      return selectedTypes
    },

    checkArrayConditions(arr) {
      const allOnes = arr.every((elem) => elem === 1)
      const allOnesAndTrue = arr.every((elem) => elem === 1 || elem === 2)
      return allOnes || allOnesAndTrue
    },

    endverify(time) {
      const start = dayjs().format('YYYY-MM-DD')
      const end = dayjs(time)
      const daysDiff = end.diff(start, 'day')
      if (daysDiff <= 0) {
        return 0
      } else if (daysDiff > 0 && daysDiff < 180) {
        return 1
      } else if (daysDiff > 180) {
        return 2
      }
    },

    // 准备提交数据
    prepareSubmitData() {
      let submitData = JSON.parse(JSON.stringify(this.form))


      // 处理经营范围长度
      if (submitData.zsopscope?.length > 200) {
        submitData.zsopscope = submitData.zsopscope.substring(0, 200)
      }

      // 添加影像信息
      submitData.fileList = this.fileList.filter(file => file.fileNo || file.fileNo)
      submitData.accountProperty = '2'


      submitData.beneficiaryList = this.form.beneficiaryList.map(beneficiary => {
        return {
          ...beneficiary,
          actConUpperMarket: this.form.actConUpperMarket ? "Y" : "N"
        };
      });

      return submitData
    },

    async ConfirmSave() {
      if (this.form.verifyCode == "") {
        this.$message.warning("请先填写验证码");
        return
      }

      const submitData = this.prepareSubmitData()

      let res
      if (this.isEditMode) {
        // 修改账户
        res = await this.api.enterpriseAccountEditApi(submitData)
      } else {
        // 开户
        res = await this.api.companyOpenApi(submitData)
      }

      if (res.code !== 200) {
        this.$message.error(res.info)
        return
      }

      this.confirmshow = false
      this.$message.success(this.isEditMode ? '修改成功' : '申请开户成功')
      this.$router.push({
        path: "/wallet/accountlist",
        query: {
          fromAddPage: !this.isEditMode
        }
      })
    },

    async ConfirmQRPush() {
      const submitData = this.prepareSubmitData()

      let taskType = this.isEditMode ? 6 : 18

      const res = await this.api.custOpenAccTaskSave({
        channelNo: submitData.channelNo,
        appNo: submitData.appNo,
        taskType: taskType,
        name: submitData.accountName,
        idNo: submitData.idNo,
        mobile: submitData.mobile,
        cardNo: submitData.primaryAccount,
        reqData: submitData
      });

      if (res.code !== 200) {
        this.$message.error(res.info);
        return;
      }

      this.confirmshow = false;
      this.qrConfirmUrl = res.data
      this.qrConfirmShow = true
    },

    async compressImage(file) {
      return new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (event) => {
          const img = new Image();
          img.src = event.target.result;
          img.onload = () => {
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');
            const maxWidth = 1920;
            const maxHeight = 1080;
            let newWidth = img.width;
            let newHeight = img.height;
            if (img.width > maxWidth) {
              newWidth = maxWidth;
              newHeight = (img.height * maxWidth) / img.width;
            }
            if (newHeight > maxHeight) {
              newHeight = maxHeight;
              newWidth = (img.width * maxHeight) / img.height;
            }
            canvas.width = newWidth;
            canvas.height = newHeight;
            ctx.drawImage(img, 0, 0, newWidth, newHeight);
            canvas.toBlob(
                (blob) => {
                  const compressedFile = new File([blob], file.name, {
                    type: 'image/jpeg',
                  });
                  resolve(compressedFile);
                },
                'image/jpeg',
                0.9
            );
          };
        };
      });
    },

    changeIdUpload(info) {
      if (this.form.channelNo == undefined)
        return this.$message.error('请先选择渠道')
      if (this.verifyvadata.FrontofidentitycardFile !== '') {
        this.verifyvadata.Frontofidentitycardloading = false
        this.verifyvadata.FrontofidentitycardFile = ''
        this.verifyvadata.Frontofidentitycardurl = ''
      }
      const isLt1M = info.file.size / 1024 / 1024 > 1;
      this.verifyvadata.Frontofidentitycardloading = true

      if (isLt1M) {
        const result = this.compressImage(info.file);
        result.then((value) => {
          this.Fileupload("01", value);
        })
      } else {
        this.Fileupload("01", info.file);
      }
    },

    changeIdBack(info) {
      if (this.form.channelNo == undefined)
        return this.$message.error('请先选择渠道')
      if (this.verifyvadata.ReverseofIDcardFile !== '') {
        this.verifyvadata.ReverseofIDcardloading = false
        this.verifyvadata.ReverseofIDcardFile = ''
        this.verifyvadata.ReverseofIDcardurl = ''
      }
      this.verifyvadata.ReverseofIDcardloading = true
      const isLt1M = info.file.size / 1024 / 1024 > 1;

      if (isLt1M) {
        const result = this.compressImage(info.file);
        result.then((value) => {
          this.Fileupload("02", value);
        })
      } else {
        this.Fileupload("02", info.file);
      }
    },

    portraitUpload(info) {
      if (this.form.channelNo == undefined)
        return this.$message.error('请先选择渠道')
      if (this.verifyvadata.BusinesslicenseFile !== '') {
        this.verifyvadata.Businesslicenseloading = false
        this.verifyvadata.BusinesslicenseFile = ''
        this.verifyvadata.Businesslicenseurl = ''
      }
      this.verifyvadata.Businesslicenseloading = true
      const isLt1M = info.file.size / 1024 / 1024 > 1;

      if (isLt1M) {
        const result = this.compressImage(info.file);
        result.then((value) => {
          this.Fileupload("12", value);
        })
      } else {
        this.Fileupload("12", info.file);
      }
    },

    changeBeneficiaryMaterialProof(info) {
      if (this.form.channelNo == undefined)
        return this.$message.error('请先选择渠道')
      if (this.verifyvadata.BeneficiaryMaterialProofFile !== '') {
        this.verifyvadata.BeneficiaryMaterialProofloading = false
        this.verifyvadata.BeneficiaryMaterialProofFile = ''
        this.verifyvadata.BeneficiaryMaterialProofurl = ''
      }
      this.verifyvadata.BeneficiaryMaterialProofloading = true

      // 检测文件类型
      const fileName = info.file.name || ''
      const ext = fileName.split('.').pop()?.toLowerCase() || ''
      const imageExts = ['png', 'jpg', 'jpeg', 'gif', 'bmp', 'tiff', 'webp']
      this.verifyvadata.BeneficiaryMaterialProofIsImage = imageExts.includes(ext)
      this.verifyvadata.BeneficiaryMaterialProofExt = ext
      this.verifyvadata.BeneficiaryMaterialProofName = fileName

      // 图片才压缩
      const isLt1M = info.file.size / 1024 / 1024 > 1;
      if (isLt1M && this.verifyvadata.BeneficiaryMaterialProofIsImage) {
        const result = this.compressImage(info.file);
        result.then((value) => {
          this.Fileupload("05", value, info.file);
        })
      } else {
        this.Fileupload("05", info.file, info.file);
      }
    },

    Fileupload(type, file, originalFile) {
      const formData = new FormData()
      formData.append('files', file)

      axios
          .post(
              urlConfig.busiURL + `/file/management/scfs/uploadscfs?channel_no=${this.form.channelNo}`,
              formData,
              {
                headers: {
                  'Content-Type': 'multipart/form-data',
                  token: getToken(),
                },
              }
          )
          .then((res) => {
            if (res.data.code !== 200) {
              this.$message.error(res.data.info)
            if (type == '01') {
              this.verifyvadata.Frontofidentitycardloading = false
            } else if (type == '02') {
              this.verifyvadata.ReverseofIDcardloading = false
            } else if (type == '12') {
              this.verifyvadata.Businesslicenseloading = false
            } else if (type == '05') {
              this.verifyvadata.BeneficiaryMaterialProofloading = false
            }
              return
            }

            if (type == '01') {
              this.$refs.IdUp.HumanfaceEcho(res.data.data[0].file_no)
              this.fileList[0].fileNo = res.data.data[0].file_no
              this.fileList[0].channel_file_no = res.data.data[0].channel_file_no
            } else if (type == '02') {
              this.$refs.IdBack.HumanfaceEcho(res.data.data[0].file_no)
              this.fileList[1].fileNo = res.data.data[0].file_no
              this.fileList[1].channel_file_no = res.data.data[0].channel_file_no
            } else if (type == '12') {
              this.$refs.Businesslicense.HumanfaceEcho(res.data.data[0].file_no)
              this.fileList[2].fileNo = res.data.data[0].file_no
              this.fileList[2].channel_file_no = res.data.data[0].channel_file_no
            } else if (type == '05') {
              this.fileList[3].fileNo = res.data.data[0].file_no
              this.fileList[3].channel_file_no = res.data.data[0].channel_file_no
              if (this.verifyvadata.BeneficiaryMaterialProofIsImage) {
                // 图片：先设置本地预览，再后台下载服务器图片
                this.verifyvadata.BeneficiaryMaterialProofurl = URL.createObjectURL(originalFile || file)
                this.verifyvadata.BeneficiaryMaterialProofFile = res.data.data[0].file_no
                this.verifyvadata.BeneficiaryMaterialProofloading = false
                this.$nextTick(() => {
                  this.$refs.BeneficiaryMaterialProofUpload?.HumanfaceEcho(res.data.data[0].file_no)
                })
              } else {
                // 非图片：直接设置文件状态
                this.verifyvadata.BeneficiaryMaterialProofFile = res.data.data[0].file_no
                this.verifyvadata.BeneficiaryMaterialProofurl = 'file'
                this.verifyvadata.BeneficiaryMaterialProofloading = false
              }
            }
          })
          .catch(() => {
          })
    },

    BusinesslicenseEdit() {
      const inputElement = this.$refs.BusinesslicenseEdit.$el.querySelector('input[type="file"]');
      inputElement.click();
    },

    ReverseofIDcardEdit() {
      const inputElement = this.$refs.ReverseofIDcard.$el.querySelector('input[type="file"]');
      inputElement.click();
    },

    FrontofidentitycardEdit() {
      const inputElement = this.$refs.Frontofidentitycard.$el.querySelector('input[type="file"]');
      inputElement.click();
    },

    BeneficiaryMaterialProofEdit() {
      const inputElement = this.$refs.BeneficiaryMaterialProof.$el.querySelector('input[type="file"]');
      inputElement.click();
    },

    removeBeneficiaryMaterialProof() {
      this.verifyvadata.BeneficiaryMaterialProofurl = '';
      this.verifyvadata.BeneficiaryMaterialProofFile = '';
      this.verifyvadata.BeneficiaryMaterialProofIsImage = true;
      this.verifyvadata.BeneficiaryMaterialProofExt = '';
      this.verifyvadata.BeneficiaryMaterialProofName = '';
    },

    // 根据文件扩展名返回图标
    getFileIcon(ext) {
      const map = {
        'pdf': 'file-pdf',
        'doc': 'file-word',
        'docx': 'file-word',
        'zip': 'file-zip',
        'rar': 'file-zip',
        '7z': 'file-zip',
      };
      return map[ext?.toLowerCase()] || 'file';
    },

    // 预览受益人文件（非图片）
    previewBeneficiaryFile() {
      if (this.verifyvadata.BeneficiaryMaterialProofIsImage) {
        // 图片走uploadImg组件预览
        this.$refs.BeneficiaryMaterialProofUpload?.Preview();
      } else {
        // 非图片：弹出文件预览modal
        this.beneficiaryFilePreviewExt = this.verifyvadata.BeneficiaryMaterialProofExt;
        this.beneficiaryFilePreviewName = this.verifyvadata.BeneficiaryMaterialProofName;
        this.beneficiaryFilePreviewVisible = true;
      }
    },

    // 下载受益人文件
    downloadBeneficiaryFile() {
      const fileNo = this.verifyvadata.BeneficiaryMaterialProofFile;
      if (!fileNo) return;

      this.api.downloadImage(fileNo).then((res) => {
        if (res.code === 200 && res.data) {
          const a = document.createElement('a');
          a.href = res.data;
          a.download = this.beneficiaryFilePreviewName || '受益人材料证明';
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        }
      });
    },

    // 一键复制受益人信息为文本
    copyBeneficiaryText() {
      if (!this.beneficiaryData) {
        this.$message.warning('暂无受益人信息可复制');
        return;
      }

      let textToCopy = '';

      // 添加公司信息
      const companyInfo = this.beneficiaryData.qccCompanyInfo;
      if (companyInfo) {
        textToCopy += '=== 公司信息 ===\n';
        textToCopy += `公司名称: ${companyInfo.name || '-'}\n`;
        textToCopy += `统一社会信用代码: ${companyInfo.creditCode || '-'}\n`;
        textToCopy += `登记状态: ${companyInfo.status || '-'}\n`;
        textToCopy += `注册资本: ${companyInfo.registCapi || '-'}\n`;
        textToCopy += `实缴资本: ${companyInfo.recCap || '-'}\n`;
        textToCopy += `法人代表: ${companyInfo.oper || '-'}\n`;
        textToCopy += `经营状态: ${companyInfo.shortStatus || '-'}\n`;
        textToCopy += `员工人数: ${companyInfo.staffs || '-'}\n`;
        textToCopy += `地址: ${companyInfo.address || '-'}\n`;

        textToCopy += `经营范围: \n  ${companyInfo.scope }\n\n`;
      }

      // 添加25%以上股权信息
      const breakthroughList = this.beneficiaryData.qccBreakThroughList || [];
      if (breakthroughList.length > 0) {
        textToCopy += '=== 25%以上股权信息 ===\n';
        breakthroughList.forEach((item, index) => {
          textToCopy += `第${index + 1}位:\n`;
          textToCopy += `  姓名: ${item.name || '-'}\n`;
          textToCopy += `  持股类型: ${item.benifitType || '-'}\n`;
          textToCopy += `  总持股比例: ${item.totalStockPercent || '-'}\n`;
          textToCopy += `  任职类型: ${item.position || '-'}\n`;
          textToCopy += `  形成日期: ${item.uboDate || '-'}\n`;

          // 股权明细
          if (item.qccBreakThroughDetailList && item.qccBreakThroughDetailList.length > 0) {
            textToCopy += `  股权明细:\n`;
            item.qccBreakThroughDetailList.forEach((detail, detailIndex) => {
              textToCopy += `    明细${detailIndex + 1}: 出资类型=${detail.capitalType || '-'}, 层级关系=${detail.path || '-'}, 持股比例=${detail.stockPercent || '-'}, 层级=${detail.level || '-'}, 持股方式=${detail.stockType || '-'}, 认缴出资额=${detail.shouldCapi || '-'}\n`;
            });
          }
          textToCopy += '\n';
        });
      }

      // 添加25%以上表决权、收益权信息
      const criterion2ndList = this.beneficiaryData.qccCriterion2ndInfoList || [];
      if (criterion2ndList.length > 0) {
        textToCopy += '=== 25%以上表决权/收益权信息 ===\n';
        criterion2ndList.forEach((item, index) => {
          textToCopy += `第${index + 1}位:\n`;
          textToCopy += `  姓名: ${item.name || '-'}\n`;
          textToCopy += `  直接持股比例: ${item.percent || '-'}\n`;
          textToCopy += `  表决权比例: ${item.votingPercent || '-'}\n`;
          textToCopy += `  总持股比例: ${item.totalStockPercent || '-'}\n`;
          textToCopy += `  形成日期: ${item.uboDate || '-'}\n\n`;
        });
      }

      // 添加控制/影响自然人信息
      const criterion3rdList = this.beneficiaryData.qccCriterion3rdInfoList || [];
      if (criterion3rdList.length > 0) {
        textToCopy += '=== 控制/影响自然人信息 ===\n';
        criterion3rdList.forEach((item, index) => {
          textToCopy += `第${index + 1}位:\n`;
          textToCopy += `  姓名: ${item.name || '-'}\n`;
          textToCopy += `  任职类型: ${item.position || '-'}\n`;
          textToCopy += `  形成日期: ${item.uboDate || '-'}\n\n`;
        });
      }

      // 添加日常经营管理人员信息
      const managerList = this.beneficiaryData.qccManagerList || [];
      if (managerList.length > 0) {
        textToCopy += '=== 日常经营管理人员信息 ===\n';
        managerList.forEach((item, index) => {
          textToCopy += `第${index + 1}位:\n`;
          textToCopy += `  姓名: ${item.name || '-'}\n`;
          textToCopy += `  任职类型: ${item.position || '-'}\n\n`;
        });
      }

      // 尝试复制到剪贴板
      this.copyToClipboard(textToCopy);
    },

    // 复制文本到剪贴板
    copyToClipboard(text) {
      if (!text) {
        this.$message.warning('没有内容可复制');
        return;
      }

      // 尝试使用现代浏览器的 Clipboard API
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(text).then(() => {
          this.$message.success('受益人信息已复制到剪贴板！');
        }).catch(err => {
          console.error('复制失败:', err);
          this.fallbackCopyText(text);
        });
      } else {
        // 降级到传统方法
        this.fallbackCopyText(text);
      }
    },

    // 降级复制方法
    fallbackCopyText(text) {
      const textArea = document.createElement('textarea');
      textArea.value = text;
      textArea.style.position = 'fixed';
      textArea.style.left = '-999999px';
      textArea.style.top = '-999999px';
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      try {
        const successful = document.execCommand('copy');
        if (successful) {
          this.$message.success('受益人信息已复制到剪贴板！');
        } else {
          this.$message.error('复制失败，请手动复制');
        }
      } catch (err) {
        console.error('复制失败:', err);
        this.$message.error('复制失败，请手动复制');
      }

      document.body.removeChild(textArea);
    },
  }
}
</script>

<style lang="less" scoped>
// 全局重置
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
}

// 覆盖 Ant Design 样式
/deep/ .ant-card-head {
  position: sticky;
  top: 0;
  z-index: 99;
  background-color: #fff;
}

/deep/ .ant-modal-content {
  width: 420px;
}

/deep/ .ant-modal-footer {
  border: none;
  padding-bottom: 20px;
}

// 主容器
.top-title {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .left {
    span:first-child {
      font-size: 16px;
      font-weight: 700;
      color: #333;
    }

    span:last-child {
      margin-left: 8px;
      color: #666;
    }
  }

  .agreement {
    margin-right: 100px;
    display: flex;
    align-items: center;

    .item {
      margin-left: 15px;

      /deep/ .ant-checkbox-wrapper {
        margin-right: 2px;
      }
    }
  }

  .right {
    button {
      height: 38px;
      margin-left: 12px;

      &:first-child {
        width: 108px;
        background-color: #1890ff;
        border-color: #1890ff;
      }

      &:last-child {
        width: 108px;
        background-color: #f5f5f5;
        color: #333;
        border-color: #d9d9d9;
      }
    }
  }
}

// 表单主区域
.Individualaccountopening {
  padding-bottom: 100px;

  // 统一表单项样式 - 主要应用于主表单区域
  /deep/ .ant-form-item {
    background-color: #fafafa;
    min-height: 56px;
    margin-bottom: 0 !important;
    border-bottom: 1px solid #e8e8e8;

    &-label {
      min-height: 56px;
      padding-left: 20px;
      display: flex;
      align-items: center;
      font-weight: 500;
      color: #333;
      white-space: nowrap;
    }

    &-control-wrapper {
      padding-left: 20px;
      background-color: #fff;
      display: flex;
      align-items: center;
      min-height: 56px;

      .ant-input,
      .ant-select,
      .ant-picker,
      .ant-input-number,
      .ant-textarea,
      .el-cascader {
        width: 200px;
        min-width: 200px;
      }
    }
  }

  // 专门为.type-fields内部的表单项重置样式 - 修复标签换行问题
  .beneficiary-item .type-fields {
    // 重置嵌套表单项的样式
    .ant-form-item {
      background-color: transparent !important;
      border: none !important;
      min-height: auto !important;
      margin-bottom: 16px !important;

      // 确保表单项使用垂直布局
      display: flex;
      flex-direction: column;
      align-items: flex-start;

      &-label {
        min-height: auto !important;
        padding-left: 0 !important;
        padding-bottom: 4px !important;
        display: block !important;
        width: 100% !important;
        text-align: left !important;
        line-height: 1.5 !important;
        font-weight: 500 !important;
        color: #333 !important;
        // 关键修复：标签保持在一行，不换行
        white-space: nowrap !important;
        overflow: visible !important;
        text-overflow: clip !important;
        // 防止标签被压缩
        flex-shrink: 0;
        // 确保标签容器有足够高度
        height: 24px !important;
        line-height: 24px !important;
        // 为长标签添加悬停提示
        position: relative;

        &:hover {
          z-index: 10;
        }

        // 当标签文字被截断时显示完整标签的tooltip
        &:hover::after {
          content: attr(data-label);
          position: absolute;
          top: 100%;
          left: 0;
          background-color: #fff;
          border: 1px solid #ddd;
          padding: 6px 12px;
          border-radius: 4px;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
          z-index: 999;
          white-space: normal;
          max-width: 300px;
          word-break: break-word;
          font-size: 12px;
          font-weight: normal;
          color: #333;
        }
      }

      &-control-wrapper {
        padding-left: 0 !important;
        background-color: transparent !important;
        min-height: 32px !important;
        // 让控制区域占据整行
        width: 100% !important;
        // 控制区域顶部添加间距
        margin-top: 4px;
      }

      // 确保所有输入组件占据整行宽度
      .ant-input,
      .ant-select,
      .ant-picker,
      .ant-input-number,
        //.ant-switch,
      .ant-textarea {
        width: 100% !important;
        max-width: 100% !important;
      }

      // 针对多行文本域的特殊处理
      .ant-textarea {
        min-height: 32px;
        resize: vertical;
      }

      // 针对数字输入框的特殊处理
      .ant-input-number {
        width: 100% !important;
      }

      // 确保日期选择器正常显示
      .ant-picker {
        width: 100% !important;
      }

      // 确保选择框正常显示
      .ant-select {
        width: 100% !important;
      }
    }

    // 针对a-row内a-col的布局优化
    .ant-row {
      margin-bottom: 16px;

      .ant-col {
        // 确保列内表单项正常显示
        .ant-form-item {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          height: 100%; // 确保列高度一致

          &-label {
            width: 100%;
            margin-bottom: 4px;
            text-align: left;
            // 确保标签在一行显示
            white-space: nowrap;
            overflow: visible;
            // 确保标签容器高度一致
            height: 24px;
            line-height: 24px;
          }

          &-control-wrapper {
            width: 100%;
            // 确保控件区域高度自适应
            flex: 1;
            display: flex;
            align-items: flex-start;

            // 确保控件本身有合适的高度
            > * {
              width: 100%;
            }
          }
        }
      }
    }
  }

  // 嵌套字段缩进
  .idType,
  .controllerIdType,
  .leaderIdType,
  .operatorIdType {
    /deep/ .ant-form-item-label {
      padding-left: 30px;
    }
  }

  // 影像上传区域
  .pricebox {
    /deep/ .ant-form-item-label {
      min-height: 180px;
      align-items: flex-start;
      padding-top: 20px;
    }

    .row {
      display: flex;
      flex-wrap: wrap;
      gap: 30px;
      margin-top: 10px;

      .item {
        display: flex;
        align-items: center;
        width: calc(33% - 20px);

        span {
          width: 100px;
          margin-right: 12px;
          white-space: nowrap;
        }

        /deep/ .ant-upload {
          width: 120px;
          height: 120px;
          border: 1px dashed #d9d9d9;
          border-radius: 4px;
          background-color: #fafafa;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;

          .anticon-plus {
            font-size: 24px;
            color: #999;
          }
        }
      }
    }

    .erero {
      color: #ff4d4d;
      font-size: 12px;
      margin-left: 112px;
      display: block;
      margin-top: 6px;
    }

    // 文件预览项
    .file-preview-item {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      position: relative;

      .file-name {
        font-size: 11px;
        color: #666;
        margin-top: 6px;
        max-width: 90px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .file-overlay {
        display: none;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        align-items: center;
        justify-content: center;
        border-radius: 4px;
        gap: 12px;
        transition: all 0.3s;

        .file-action {
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;

          /deep/ .anticon svg {
            font-size: 22px;
            color: #fff;
          }
        }
      }

      &:hover .file-overlay {
        display: flex !important;
      }
    }
  }

  // 分组标题
  .legalrepresentative,
  .actualcontroller,
  .personincharge,
  .agent,
  .beneficiary {
    height: 50px;
    padding-left: 20px;
    display: flex;
    align-items: center;
    font-weight: 600;
    color: #1890ff;
    background-color: #f0f9ff;
    border-left: 4px solid #1890ff;

    .fill {
      margin-left: 20px;
      height: 28px;
      font-size: 12px;
    }
  }

  // 受益人提示
  .beneficiary-tips {
    background-color: #fffbe6;
    border: 1px solid #ffe58f;
    border-radius: 4px;
    padding: 12px;
    margin: 16px 0;
    font-size: 13px;
    color: #595959;

    ul {
      margin: 8px 0 0 20px;
      padding: 0;

      li {
        margin-bottom: 4px;
        line-height: 1.5;
      }
    }
  }

  // 受益人项
  .beneficiary-item {
    margin-bottom: 24px;
    padding: 20px;
    background-color: #fff;
    border: 1px solid #e8e8e8;
    border-radius: 6px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.03);

    .beneficiary-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 16px;
      padding-bottom: 12px;
      border-bottom: 1px solid #f0f0f0;

      span {
        font-weight: 600;
        color: #1890ff;
      }

      .ant-btn-link {
        padding: 0;
        height: auto;
        line-height: 1;
      }
    }

    // 基础信息表单项
    /deep/ .ant-form-item {
      background-color: transparent !important;
      border: none;
      margin-bottom: 16px !important;
      min-height: auto;

      &-label {
        padding-left: 0;
        min-height: auto;
        line-height: 32px;
        // 确保基础信息标签也在一行显示
        white-space: nowrap;
        overflow: visible;
      }

      &-control-wrapper {
        background-color: transparent !important;
        padding-left: 0 !important;
        border: none;
        min-height: auto;
      }

      // 确保输入组件不会太宽
      .ant-input,
      .ant-select,
      .ant-picker,
      .ant-input-number,
      .ant-textarea {
        width: 100% !important;
        max-width: 400px;
      }
    }

    // 类型字段容器
    .type-fields {
      background-color: #f9f9f9;
      border: 1px solid #e8e8e8;
      border-radius: 6px;
      padding: 16px;
      margin-top: 12px;
      overflow: visible;

      .type-fields-header {
        font-weight: 600;
        color: #1890ff;
        margin-bottom: 12px;
        padding-bottom: 8px;
        border-bottom: 1px solid #eee;
      }
    }

    // 复选框组
    .ant-checkbox-group {
      display: flex;
      flex-wrap: wrap;
      gap: 12px;
    }

    .ant-checkbox-wrapper {
      margin-right: 0 !important;
    }
  }

  // 确认/取消模态框
  .confirmloading {
    .text,
    .canceltext {
      text-align: center;
      font-size: 16px;
      color: #333;
      padding: 20px 0;
    }

    .custom-footer {
      text-align: center;

      button {
        margin: 0 8px;

        &:first-child {
          background-color: #1890ff;
          border-color: #1890ff;
        }

        &:last-child {
          background-color: #f5f5f5;
          color: #333;
          border-color: #d9d9d9;
        }
      }
    }
  }
}

// 响应式优化
@media (max-width: 1200px) {
  .pricebox .item {
    width: calc(50% - 15px);
  }

  // 在小屏幕上调整.type-fields内的布局
  .beneficiary-item .type-fields {
    .ant-col {
      width: 100% !important;
      flex: 0 0 100% !important;
      max-width: 100% !important;
      margin-bottom: 16px !important;

      .ant-form-item-label {
        // 在小屏幕上，如果标签太长，允许换行
        white-space: normal !important;
        height: auto !important;
        line-height: 1.5 !important;
      }
    }
  }
}

@media (max-width: 768px) {
  .pricebox .item {
    width: 100%;
  }

  .beneficiary-item .type-fields {
    .ant-col {
      width: 100% !important;
      flex: 0 0 100% !important;
      max-width: 100% !important;

      .ant-form-item-label {
        // 在手机屏幕上，标签允许换行
        white-space: normal !important;
        height: auto !important;
        line-height: 1.5 !important;
      }
    }
  }

  .top-title .right button {
    width: 90px;
    font-size: 13px;
  }
}

// 受益人查询结果样式
.beneficiary-result {
  .ant-divider {
    margin: 16px 0;
    font-weight: 600;
  }

  .beneficiary-section {
    margin-bottom: 16px;
  }

  .ant-descriptions {
    margin-bottom: 8px;
  }

  .ant-table {
    font-size: 12px;
  }
}
</style>
